// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:16:29.407Z
// Property: Hampton Place (ID: 6737460151191758)
// Collections: 27 amenities, 9 floorplans (live), 52 photos, 41 POIs, 4 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151191758",
  "property_external_id": "4601281",
  "property_zillow_url": "https://www.zillow.com/b/hampton-place-apartments-columbus-ga-B6tnTY/",
  "property_apartments_url": "https://www.apartments.com/hampton-place-columbus-ga/4zew66l",
  "property_google_business_url": "https://www.google.com/maps/place/Hampton+Place/data=!4m2!3m1!1s0x0:0xf3691dc49bda7cc2?sa=X&ved=2ahUKEwje27GmurySAxUuQ_EDHRGfA7wQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321196192",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "hampton-place",
  "property_name": "Hampton Place",
  "property_website_url": "https://www.hamptonplaceapts.com/",
  "property_domain": "https://www.hamptonplaceapts.com/",
  "property_address": "6515 Thea Ln",
  "property_full_address": "6515 Thea Ln, Columbus, GA 31907",
  "property_address_1": "6515 Thea Ln",
  "property_address_2": null,
  "property_address_city": "Columbus",
  "property_address_state": "GA",
  "property_address_zip_full": "31907-2459",
  "property_address_zip": "31907",
  "property_address_country": "US",
  "property_address_county": "Muscogee County",
  "property_neighborhood_address": "East Columbus",
  "property_address_latitude": "32.5273002",
  "property_address_longitude": "-84.8833379",
  "property_email": "hamptonplace.mgr@rreafresidential.com",
  "property_phone": "(706) 563-7401",
  "property_call_tracking_phone": "706-600-2546",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Hampton Place, where comfort meets convenience in Columbus, GA. Our vibrant apartment community offers spacious one, two, and three-bedroom floor plans, complemented by stellar amenities like a refreshing pool, fitness center, and serene dog park. Dive into your new lifestyle—browse our availability or schedule a tour today!",
  "property_long_description": "Welcome to Hampton Place, your ideal apartment community nestled in the heart of Columbus, GA. Offering a diverse selection of floor plans, including spacious one-bedroom, two-bedroom, and three-bedroom options, Hampton Place is designed to meet your lifestyle needs. \n\nOur community boasts a wealth of amenities that provide both comfort and entertainment. Dive into relaxation at our inviting pool, stay active at our state-of-the-art fitness center, or unwind with friends at our clubhouse. Families will appreciate the dedicated playground, while pet owners can enjoy the dog park and pet play area where furry friends can roam freely. \n\nHampton Place also prioritizes your convenience with features like on-site laundry facilities, package services, and a professional property management team to ensure a stress-free living experience. Enjoy the outdoors? Our beautifully landscaped picnic area, serene pond, and sun-drenched sundeck offer perfect spots for unwinding with nature. For those who love to stay active, take advantage of our tennis and volleyball courts!\n\nYour new apartment will be equipped with modern conveniences such as air conditioning, spacious walk-in closets, dishwasher, and in-unit washer/dryer hookups. Many of our apartments feature charming patios and balconies that provide additional living space to enjoy your surroundings.\n\nThe vibrant community at Hampton Place is designed for those who value quality living and connectivity. Don’t miss out on your chance to join our welcoming neighborhood. Find your new home today—browse our availability or schedule a tour to visit our community!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-7f43-75ae-9a3c-3ea693a48166.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with a fountain and lounge chairs, surrounded by palm trees and landscaping.",
    "public_id": "019d076e-7f43-75ae-9a3c-3ea693a48166",
    "storage_key": "property/6737460151191758/019d076e-7f43-75ae-9a3c-3ea693a48166.webp",
    "width": 1500,
    "height": 1000
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "390",
  "property_year_built": "1986",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.87179487179486",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "One-Time Move-In Fees\nAdministrative Fee\n$100\nApplication Fee\n$65",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "We welcome two pets per apartment home. There is a one time $400 non-refundable pet fee for one pet, and $600 for two pets. Pet rent would be $15 per month per pet.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://hamptonplaceapartments.loftliving.com/login",
  "property_apply_now_url": "https://8114739.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076d-8398-774e-9aca-96eed0b7b485.webp",
  "property_primary_logo_media": {
    "alt_text": "Hampton Place Apartments logo.",
    "public_id": "019d076d-8398-774e-9aca-96eed0b7b485",
    "storage_key": "property/6737460151191758/019d076d-8398-774e-9aca-96eed0b7b485.webp",
    "width": 750,
    "height": 172
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e847a-2836-7767-b7da-d1f37b2fd2f3.webp",
  "property_secondary_logo_media": {
    "alt_text": "Hampton Place Apartments logo",
    "public_id": "019e847a-2836-7767-b7da-d1f37b2fd2f3",
    "storage_key": "property/6737460151191758/019e847a-2836-7767-b7da-d1f37b2fd2f3.webp",
    "width": 1100,
    "height": 251
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_fav_icon_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595d-b89d-716c-8cb0-24426d93f0d6",
    "storage_key": "company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
    "width": 225,
    "height": 225
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e847a-2836-7767-b7da-d1f37b2fd2f3.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Hampton Place Apartments logo",
    "public_id": "019e847a-2836-7767-b7da-d1f37b2fd2f3",
    "storage_key": "property/6737460151191758/019e847a-2836-7767-b7da-d1f37b2fd2f3.webp",
    "width": 1100,
    "height": 251
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e1e43-221a-71dc-936a-1444fd1614b4.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e1e43-221a-71dc-936a-1444fd1614b4",
    "storage_key": "property/6737460151191758/019e1e43-221a-71dc-936a-1444fd1614b4.webp",
    "width": 750,
    "height": 172
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#081b54",
  "property_secondary_color": "#e5f6ff",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "568 - 1502",
  "property_sqft_min": "568",
  "property_sqft_max": "1502",
  "property_price_range": "750 - 1460",
  "property_price_min": "750",
  "property_price_max": "1460",
  "property_available_units": 20,
  "property_facebook_url": "https://www.facebook.com/HamptonPlaceApt",
  "property_instagram_url": "https://www.instagram.com/hampton_place_rrliving/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJW7HjJ3Q084gRwnzam8QdafM",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/hampton-place-apartments-chastain-property-management-columbus",
  "property_tiktok_url": "https://www.tiktok.com/@hampton.place",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Hampton Place",
  "property_home_romance_title": "Experience the Joy of Living in Your Dream Apartment",
  "property_home_amenities_blurb": "<p>Welcome home to Hampton Place Apartments! Located in the quaint town of Columbus, Georgia, we offer access to several public parks and numerous historical sites. You will love the convenience of being close to shopping, fine dining, and ample entertainment. <a href=\"/neighborhood/\">Our location</a> provides easy access to Interstate 185, making your stressful commute a thing of the past. We strive to accommodate your lifestyle and offer the best of Columbus living at <a href=\"/floor-plans/\">Hampton Place Apartments</a>.</p>",
  "property_home_floorplans_blurb": "<p><a href=\"/floor-plans/\">Hampton Place Apartments</a> in Columbus, GA is surrounded by exciting destinations that are only minutes away. Check out wonderful restaurants, shopping, and entertainment. Our location makes life simpler.</p>",
  "property_home_gallery_blurb": "At Hampton Place in Columbus, GA, choose from spacious one, two, or three-bedroom layouts that perfectly fit your lifestyle. Enjoy exclusive amenities including a sparkling pool, fitness center, and pet-friendly spaces. With luxurious details like walk-in closets and modern kitchens, picture yourself living here—where comfort meets convenience.",
  "property_home_neighborhood_blurb": "At Hampton Place in Columbus, GA, enjoy spacious one, two, and three-bedroom floor plans, complemented by vibrant neighborhood amenities. Unwind at nearby parks, immerse yourself in the Columbus Collective Museums, or stay active at Crunch Fitness. Your perfect living space is just a step away from adventure and convenience!",
  "property_home_reviews_blurb": "Welcome to Hampton Place, where spacious living meets exceptional service! Our residents rave about the \"nice staff\" and the community's abundant amenities, including two saltwater pools and a well-maintained gym. Enjoy a convenient lifestyle in Columbus, GA, ideal for singles and families alike. Check out what our residents love about us!",
  "property_neighborhood_blurb": "<p><a href=\"/floor-plans/\">Hampton Place Apartments</a> in Columbus, GA is surrounded by exciting destinations that are only minutes away. Check out wonderful restaurants, shopping, and entertainment. Our location makes life simpler.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Our community amenities are second-to-none, and residents enjoy unlimited access. Amenities include a 24-hour courtesy patrol, beautiful landscaping, a clubhouse, gated access, a laundry facility, on-call maintenance, a picnic area with barbecue, a play area, and access to a pond. Staying in shape is easy with our two saltwater swimming pools and tennis court. Come by and see what makes <a href=\"/floor-plans/\">Hampton Place Apartments</a> a great place to call home.</p>",
  "property_applynow_blurb": "At Hampton Place in Columbus, GA, your ideal home awaits among our diverse floor plans—from cozy one-bedrooms to spacious three-bedrooms. Indulge in fantastic amenities like a resort-style pool, fitness center, and dog park. Embrace comfort and convenience; lease your dream apartment online today!",
  "property_contactus_blurb": "At Hampton Place in Columbus, GA, your perfect living space awaits! Choose from thoughtfully designed one, two, or three-bedroom floor plans tailored to fit your lifestyle. Whether you seek cozy comfort or room to grow, we’re here to help. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At Hampton Place in Columbus, GA, we offer thoughtfully designed one, two, and three-bedroom floor plans perfect for every lifestyle. Have questions? Our FAQs page is your go-to resource for information about living in our vibrant community. Dive in and find the answers you need today!",
  "property_floorplans_blurb": "<p>Choose from our studio, one, two, and three bedroom apartment homes for rent. <a href=\"/amenities/\">Spacious floor plans</a> with gourmet kitchens make entertaining your family and friends a breeze. Kick back and relax on your balcony or patio, or you could stay comfortable indoors with our central air and heating. We are a pet-friendly community and offer a dog park.</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our community and apartments.</p>",
  "property_interactivemap_blurb": "At Hampton Place in Columbus, GA, your next home awaits with spacious one, two, and three-bedroom floor plans tailored for comfort. Enjoy resort-style amenities like a sparkling pool, fitness center, and dog park. Use our interactive community map to find your perfect apartment today! Embrace a lifestyle of convenience and leisure.",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At Hampton Place in Columbus, GA, your ideal living space awaits—whether you seek a cozy one-bedroom or a spacious three-bedroom apartment. Great friends make great neighbors; refer a friend to share in the comfort and community spirit that defines our vibrant lifestyle today!",
  "property_residentaccess_blurb": "At Hampton Place in Columbus, GA, our thoughtfully designed one, two, and three-bedroom apartments elevate your living experience. Enhance your community involvement with ease—access your resident portal to pay rent, schedule maintenance, and enjoy a seamless lifestyle tailored just for you. Your comfort is our priority!",
  "property_reviews_blurb": "At Hampton Place in Columbus, GA, residents cherish the spacious apartments and the welcoming atmosphere. One resident highlights, \"The staff is courteous,\" while enjoying amenities like two saltwater pools and updated gym facilities. Join our vibrant community where friendly neighbors and convenience come together—experience a home that truly fits your lifestyle!",
  "property_created_at": "1752257091008",
  "property_scheduletour_blurb": "At Hampton Place in Columbus, GA, our thoughtfully designed floor plans—ranging from one to three bedrooms—offer the perfect blend of comfort and style. Experience vibrant living and discover firsthand why our residents adore their homes. Schedule a tour today and join the Hampton Place community!",
  "property_thankyou_blurb": "Thank you for showing interest in Hampton Place in Columbus, GA! Our thoughtfully designed apartments come in one, two, and three-bedroom floor plans, offering the perfect blend of comfort and style. A member of our team will reach out soon to assist you in finding your ideal home.",
  "property_virtualtours_blurb": "<p>At Hampton Place, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. Hampton Place",
  "property_seo_title_home": "Hampton Place |  Apartments in Columbus, GA",
  "property_seo_description_home": "Experience vibrant living at Hampton Place in Columbus, GA. Choose from spacious one to three-bedroom apartments with top amenities. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Columbus, GA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Hampton Place in Columbus, GA! Check out our unique one, two, and three-bedroom floor plans designed for comfort and style.",
  "property_seo_title_amenities": "Amenities | Columbus, GA Apartments for Rent",
  "property_seo_description_amenities": "Experience life at Hampton Place in Columbus, GA. Enjoy resort-style amenities like a pool, fitness center, dog park, and spacious floor plans tailored for you!",
  "property_seo_title_gallery": "Gallery | Apartments in Columbus, GA",
  "property_seo_description_gallery": "Picture life at Hampton Place in Columbus, GA! Relax by the pool, unwind in our clubhouse, or enjoy your favorite amenities—your perfect home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Hampton Place Apartments",
  "property_seo_description_virtualtours": "Experience Hampton Place in Columbus, GA! Take a virtual tour of our stunning one, two, and three-bedroom apartments—your perfect home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Hampton Place Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Hampton Place in Columbus, GA! Use our interactive map to explore one, two, or three-bedroom apartments and vibrant amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Columbus, GA",
  "property_seo_description_neighborhood": "Uncover the vibrant life around Hampton Place in Columbus, GA. From local favorites to hidden gems, see what makes our neighborhood truly special!",
  "property_seo_title_contact": "Contact Us | Hampton Place",
  "property_seo_description_contact": "Connect with the Hampton Place team in Columbus, GA! Whether you need info on one, two, or three-bedroom floor plans, we're here to assist you.",
  "property_seo_title_faqs": "FAQs | Apartments in Columbus, GA",
  "property_seo_description_faqs": "Find quick answers to your questions about life at Hampton Place in Columbus, GA. Learn about amenities, floor plans, and everything that makes us home!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Columbus, GA",
  "property_seo_description_reviews": "Join the vibrant community at Hampton Place in Columbus, GA! Uncover genuine resident insights and see why our homes and amenities make life here exceptional!",
  "property_seo_title_applynow": "Apply Now | Apartments in Columbus, GA",
  "property_seo_description_applynow": "Find your haven at Hampton Place in Columbus, GA! Enjoy spacious floor plans, top-notch amenities, and pet-friendly living. Lease online and start home today!",
  "property_seo_title_residentaccess": "Resident Access | Hampton Place",
  "property_seo_description_residentaccess": "Unlock convenience at Hampton Place in Columbus, GA. Access your resident portal for easy rent payments, maintenance requests, and essential community updates!",
  "property_seo_title_referafriend": "Refer A Friend | Hampton Place",
  "property_seo_description_referafriend": "Refer a friend to Hampton Place in Columbus, GA! Enjoy vibrant living and build lasting connections in a community where great friends become great neighbors.",
  "property_seo_title_scheduletour": "Schedule a Tour | Hampton Place",
  "property_seo_description_scheduletour": "Experience the charm of Hampton Place in Columbus, GA. Schedule a tour today and see why our vibrant community feels like home sweet home!",
  "property_seo_title_privacy": "Privacy Policy | Hampton Place",
  "property_seo_description_privacy": "At Hampton Place in Columbus, GA, your privacy matters. Learn how we protect your information and maintain a secure, welcoming community. Read our policy now!",
  "property_seo_title_accessibility": "Website Accessibility | Hampton Place",
  "property_seo_description_accessibility": "At Hampton Place in Columbus, GA, we prioritize digital inclusion. Our commitment ensures everyone can access and enjoy our vibrant apartment community seamlessly.",
  "property_seo_title_sitemap": "Sitemap | Hampton Place",
  "property_seo_description_sitemap": "Uncover the best of Hampton Place in Columbus, GA! Navigate our community amenities, floor plans, and more with our user-friendly sitemap. Access it now!",
  "property_seo_title_thankyou": "Thank You | Hampton Place",
  "property_seo_description_thankyou": "Thank you for your interest in Hampton Place! Stay tuned—our team will reach out soon to help you find your new home in vibrant Columbus, GA.",
  "property_seo_title_pets": "Pet Policy | Apartments in Columbus, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293615889",
  "amenities": [
    {
      "id": "ec_cf403ea411bd892aeba65bd7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "external_id": "false",
      "title": "24‑hour Courtesy Patrol",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7d8d50e9c6f4eff75e6dde60",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "external_id": "false",
      "title": "Beautiful Landscaping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f9bbbfa53f9371580213d8af",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d1084e9e6a9fc1827de21c7e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_561508bf1bba416e4c67b45c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a19bf32f2fbad078760ebe33",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "external_id": "false",
      "title": "Laundry Facility",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_21f8dd2a37ee2b0f60c23698",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "external_id": "false",
      "title": "On‑call Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_958cff47a5eac43d6cbf0e83",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "external_id": "false",
      "title": "Picnic Area With Barbecue",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b9e2784877d6f57ea0d4bbd8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "external_id": "false",
      "title": "Play Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0072a123f530dfe4fcabcdf9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "external_id": "false",
      "title": "Pond",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3ff1a5c98068e51ec1d65109",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "external_id": "false",
      "title": "Resident Events",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_48f5fef951980291b2668aa0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "external_id": "false",
      "title": "Tennis Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_30a199fadec681b135dcaf78",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "external_id": "false",
      "title": "Two Saltwater Swimming Pools",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_deab0a07483030298ecf168b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "external_id": "false",
      "title": "All‑Electric Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_29f5736748328e17d1df58f3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "external_id": "false",
      "title": "Balcony or Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fac9dcd6aaa4cdea486acc3c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7ac021697922477e05507f54",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "external_id": "false",
      "title": "Carpeted Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_81164dac898ee40b0ef65b65",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7e854e6b90327d4b7166c2a3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "external_id": "false",
      "title": "Central Air and Heating",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_325a27f28d146226eca8cc85",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5eac0fbcd1354a0c14a4c378",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "external_id": "false",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d093e7188a1c0bcfb802ae14",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d218a10364a981b2e5fb9db2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "external_id": "false",
      "title": "Mini Blinds",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_adc9de6b3d03db902ca58212",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "external_id": "false",
      "title": "Mirrored Closet Doors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_48d1a336fba68c391d5b83d2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d3a6b29c905b07dd06a0382a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "external_id": "false",
      "title": "Vertical Blinds",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e4a996737f1bde1a1d322214",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "external_id": "false",
      "title": "Washer and Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_523031c3-fb31-4c1d-9ce8-eb2e2a6c50e1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e847a-2c81-778b-a00b-0fbad1cd6a01.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with waterfall and lounge chairs.",
        "public_id": "019e847a-2c81-778b-a00b-0fbad1cd6a01",
        "storage_key": "property/6737460151191758/019e847a-2c81-778b-a00b-0fbad1cd6a01.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our beautiful resort-style swimming pool, complete with a stunning waterfall and ample lounge chairs for relaxation.",
      "link": "",
      "alt_text": "Resort-style swimming pool with waterfall and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0f7b948d-21cf-45a3-8c26-b01a19ddaa16",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076d-af3f-77c6-9e99-e75204ec762b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark blue cabinets, white subway tile backsplash, and granite countertops.",
        "public_id": "019d076d-af3f-77c6-9e99-e75204ec762b",
        "storage_key": "property/6737460151191758/019d076d-af3f-77c6-9e99-e75204ec762b.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Discover a beautifully designed kitchen featuring sleek dark blue cabinetry, elegant white subway tile, and durable granite countertops. Perfect for culinary adventures.",
      "link": "",
      "alt_text": "Modern kitchen with dark blue cabinets, white subway tile backsplash, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3c945103-c0a5-4785-8fee-736ea08708a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-3850-72ee-9679-78060b626528.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, armchair, ottoman, coffee table, and fireplace.",
        "public_id": "019e8479-3850-72ee-9679-78060b626528",
        "storage_key": "property/6737460151191758/019e8479-3850-72ee-9679-78060b626528.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a plush sofa, comfortable armchair, decorative ottomans, and a cozy fireplace, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with a sofa, armchair, ottoman, coffee table, and fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e31aba77-6a18-4129-9489-ee7df56986df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-6d80-77aa-a368-778262ed20f2.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, built-in shelves, and kitchen view.",
        "public_id": "019e8479-6d80-77aa-a368-778262ed20f2",
        "storage_key": "property/6737460151191758/019e8479-6d80-77aa-a368-778262ed20f2.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a cozy fireplace, ample built-in shelving, and a glimpse into the modern kitchen.",
      "link": "",
      "alt_text": "Living room with fireplace, built-in shelves, and kitchen view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_da8d1cf4-6a64-49ee-91ef-2ce28c925f6a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-6f5b-73ce-9a70-c4019e3d6f62.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark blue cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019e8479-6f5b-73ce-9a70-c4019e3d6f62",
        "storage_key": "property/6737460151191758/019e8479-6f5b-73ce-9a70-c4019e3d6f62.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Step into this stylish kitchen featuring dark blue cabinetry, sleek granite countertops, and modern stainless steel appliances, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with dark blue cabinets, granite countertops, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c53e2f10-0be6-4861-9fa6-818c70ea2e20",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-85c6-716c-bfc8-d052ca769277.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with dark blue cabinets and granite countertop.",
        "public_id": "019e8479-85c6-716c-bfc8-d052ca769277",
        "storage_key": "property/6737460151191758/019e8479-85c6-716c-bfc8-d052ca769277.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious bathroom vanity featuring dark blue cabinetry, a granite countertop, and a large mirror with a light fixture.",
      "link": "",
      "alt_text": "Modern bathroom vanity with dark blue cabinets and granite countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d4a0b1fb-820e-4cfb-9c71-7cb2e61fa007",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e847a-4dbf-732c-8e0f-d38e3a06d982.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and seating areas with red umbrellas.",
        "public_id": "019e847a-4dbf-732c-8e0f-d38e3a06d982",
        "storage_key": "property/6737460151191758/019e847a-4dbf-732c-8e0f-d38e3a06d982.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded seating areas perfect for enjoying a sunny day.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and seating areas with red umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d66f9190-e519-40c0-860a-8e503c0d55eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e847a-2c7a-76c8-af90-2a2fd208859f.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees outside apartment buildings.",
        "public_id": "019e847a-2c7a-76c8-af90-2a2fd208859f",
        "storage_key": "property/6737460151191758/019e847a-2c7a-76c8-af90-2a2fd208859f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning outdoor swimming pool, surrounded by lush landscaping and comfortable lounge seating. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees outside apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2c73d030-0dfc-49f3-a930-bed62911c581",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e847a-25c3-76bf-87e1-cde8604c9ac4.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019e847a-25c3-76bf-87e1-cde8604c9ac4",
        "storage_key": "property/6737460151191758/019e847a-25c3-76bf-87e1-cde8604c9ac4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning swimming pool, surrounded by lush landscaping and comfortable lounge seating. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0ae9f1f1-196a-4ae2-baa1-481c25b32cbd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e847a-2c06-72ec-b620-c71d962118a0.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with red lounge chairs and a stone waterfall.",
        "public_id": "019e847a-2c06-72ec-b620-c71d962118a0",
        "storage_key": "property/6737460151191758/019e847a-2c06-72ec-b620-c71d962118a0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush landscaping and comfortable lounge chairs. Relax and unwind by the poolside waterfall.",
      "link": "",
      "alt_text": "Resort-style swimming pool with red lounge chairs and a stone waterfall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7505c1ba-755c-4d10-9189-b3a902e6fa5a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e847a-1e34-767a-8356-f0f39cb73af8.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and a stone waterfall feature.",
        "public_id": "019e847a-1e34-767a-8356-f0f39cb73af8",
        "storage_key": "property/6737460151191758/019e847a-1e34-767a-8356-f0f39cb73af8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and a beautiful stone waterfall. Perfect for relaxation and fun.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and a stone waterfall feature.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c12a5e0e-e5c8-4c95-8fed-a988a954a7fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e847a-2c0c-71db-9ff4-0709146641f6.webp",
      "image_media": {
        "alt_text": "Two lounge chairs facing a swimming pool with a rock waterfall feature and lush trees in the background.",
        "public_id": "019e847a-2c0c-71db-9ff4-0709146641f6",
        "storage_key": "property/6737460151191758/019e847a-2c0c-71db-9ff4-0709146641f6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool, complete with a tranquil rock waterfall and comfortable lounge chairs, surrounded by beautiful landscaping.",
      "link": "",
      "alt_text": "Two lounge chairs facing a swimming pool with a rock waterfall feature and lush trees in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_88ff8805-90c1-4b22-a77b-873ce46f1199",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e847a-2b04-7534-a2f2-6cb9348e082e.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at a multifamily property.",
        "public_id": "019e847a-2b04-7534-a2f2-6cb9348e082e",
        "storage_key": "property/6737460151191758/019e847a-2b04-7534-a2f2-6cb9348e082e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and shaded umbrellas. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_80068a12-85ed-400e-ba8d-5f05261da60a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e847a-2b7c-700e-b32d-c97f9963203a.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019e847a-2b7c-700e-b32d-c97f9963203a",
        "storage_key": "property/6737460151191758/019e847a-2b7c-700e-b32d-c97f9963203a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded umbrellas for a perfect day in the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_08d75561-1866-4d65-8ae1-5073256f7245",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-c1c8-7333-8faa-f7ad94b584f0.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a palm tree in front of a building.",
        "public_id": "019e8479-c1c8-7333-8faa-f7ad94b584f0",
        "storage_key": "property/6737460151191758/019e8479-c1c8-7333-8faa-f7ad94b584f0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush landscaping and comfortable lounge seating. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a palm tree in front of a building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7f2a39e1-89c1-432c-a436-683ca9a4f366",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-c407-73ca-b60a-0c44dd6d0fcc.webp",
      "image_media": {
        "alt_text": "Bright blue swimming pool with lounge chairs and palm trees.",
        "public_id": "019e8479-c407-73ca-b60a-0c44dd6d0fcc",
        "storage_key": "property/6737460151191758/019e8479-c407-73ca-b60a-0c44dd6d0fcc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush landscaping and comfortable lounge areas.",
      "link": "",
      "alt_text": "Bright blue swimming pool with lounge chairs and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fdeb6afe-1e10-49f1-b5b7-5a12bb4d6faf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-be30-714e-ac0d-051cad317efe.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019e8479-be30-714e-ac0d-051cad317efe",
        "storage_key": "property/6737460151191758/019e8479-be30-714e-ac0d-051cad317efe.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded areas.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_880f1862-f02f-4696-8dc7-3f84a91a3f8e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-964f-7157-b1b1-fd3893cd2ca8.webp",
      "image_media": {
        "alt_text": "Sparkling swimming pool with lounge chairs and a stone waterfall feature.",
        "public_id": "019e8479-964f-7157-b1b1-fd3893cd2ca8",
        "storage_key": "property/6737460151191758/019e8479-964f-7157-b1b1-fd3893cd2ca8.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our beautiful swimming pool, complete with comfortable lounge chairs and a relaxing stone waterfall.",
      "link": "",
      "alt_text": "Sparkling swimming pool with lounge chairs and a stone waterfall feature.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_78db4d3d-2baf-4606-8d13-018981a82470",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-abce-750e-8e80-5210467d5cc4.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs, umbrella-covered dining table, and waterfall feature.",
        "public_id": "019e8479-abce-750e-8e80-5210467d5cc4",
        "storage_key": "property/6737460151191758/019e8479-abce-750e-8e80-5210467d5cc4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, complete with a relaxing waterfall and comfortable lounge seating. Perfect for unwinding.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with lounge chairs, umbrella-covered dining table, and waterfall feature.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_738d9c5b-f7cc-473a-82bf-d56b95a6dea2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-bc4a-77a3-9aac-1582de50a423.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with red chairs and tables next to a building with a black awning and wooden balcony.",
        "public_id": "019e8479-bc4a-77a3-9aac-1582de50a423",
        "storage_key": "property/6737460151191758/019e8479-bc4a-77a3-9aac-1582de50a423.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the outdoors with ample seating in our community spaces, perfect for relaxing or socializing.",
      "link": "",
      "alt_text": "Outdoor seating area with red chairs and tables next to a building with a black awning and wooden balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_38a3c04d-668e-4a38-89ba-2ed5569b6ce4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-8e23-71de-ad33-3106fae9d2f6.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with parking lot and landscaping.",
        "public_id": "019e8479-8e23-71de-ad33-3106fae9d2f6",
        "storage_key": "property/6737460151191758/019e8479-8e23-71de-ad33-3106fae9d2f6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of the apartment building, showcasing the property's architecture and surrounding lush landscaping.",
      "link": "",
      "alt_text": "Exterior view of apartment building with parking lot and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_943acba5-e34d-4307-8244-f16180e9fae1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-a524-7319-b993-c1004901c635.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a waterfall feature.",
        "public_id": "019e8479-a524-7319-b993-c1004901c635",
        "storage_key": "property/6737460151191758/019e8479-a524-7319-b993-c1004901c635.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our sparkling swimming pool, complete with comfortable lounge chairs and a relaxing waterfall feature. Perfect for a sunny afternoon.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and a waterfall feature.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1a4cbb51-8831-45be-bdf7-f68a9f8753ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-9533-77df-bd6f-3e08b98d5256.webp",
      "image_media": {
        "alt_text": "A serene courtyard fountain with lush red roses in the foreground and apartment buildings in the background.",
        "public_id": "019e8479-9533-77df-bd6f-3e08b98d5256",
        "storage_key": "property/6737460151191758/019e8479-9533-77df-bd6f-3e08b98d5256.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the tranquil atmosphere of our property with this beautiful courtyard fountain, surrounded by vibrant roses and shaded seating areas. A perfect spot to relax and unwind.",
      "link": "",
      "alt_text": "A serene courtyard fountain with lush red roses in the foreground and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_76153d91-9696-4bba-a4e8-4c0598765f3e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-8607-7438-a370-aece8c1cdf2d.webp",
      "image_media": {
        "alt_text": "Closet with louvered doors and a shelf, next to a vanity with a sink and mirror.",
        "public_id": "019e8479-8607-7438-a370-aece8c1cdf2d",
        "storage_key": "property/6737460151191758/019e8479-8607-7438-a370-aece8c1cdf2d.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious closet with louvered doors, perfect for storage. Adjacent to a modern bathroom vanity featuring a granite countertop, sink, and mirror.",
      "link": "",
      "alt_text": "Closet with louvered doors and a shelf, next to a vanity with a sink and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fb19b63b-39da-43b3-973c-2d5ba2698d60",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-76b5-7099-9049-e4c71a14f58e.webp",
      "image_media": {
        "alt_text": "Bedroom with mirrored closet doors and a ceiling fan",
        "public_id": "019e8479-76b5-7099-9049-e4c71a14f58e",
        "storage_key": "property/6737460151191758/019e8479-76b5-7099-9049-e4c71a14f58e.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, mirrored closet doors, and ample wall space for personalization. Enjoy the natural light from the window.",
      "link": "",
      "alt_text": "Bedroom with mirrored closet doors and a ceiling fan",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6d363490-b568-4d96-8e4c-e598988c8fb7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-71b9-725f-b5fb-0853907c0305.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace and a ceiling fan",
        "public_id": "019e8479-71b9-725f-b5fb-0853907c0305",
        "storage_key": "property/6737460151191758/019e8479-71b9-725f-b5fb-0853907c0305.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a cozy fireplace, a ceiling fan, and a sliding glass door leading to a balcony. The room has wood-look flooring and neutral walls.",
      "link": "",
      "alt_text": "Living room with a fireplace and a ceiling fan",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1fc90dec-6437-4e9f-8355-33c9eeb3f708",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-76ac-747f-b4c4-e76961dc8ea3.webp",
      "image_media": {
        "alt_text": "Bathroom with bathtub and toilet",
        "public_id": "019e8479-76ac-747f-b4c4-e76961dc8ea3",
        "storage_key": "property/6737460151191758/019e8479-76ac-747f-b4c4-e76961dc8ea3.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a bathtub, shower, and toilet, offering a comfortable and convenient space for residents.",
      "link": "",
      "alt_text": "Bathroom with bathtub and toilet",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_810f48e4-3122-4694-ac3d-ef56592f5546",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-71a8-718d-ab26-d681dee3cb67.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a ceiling fan and mirrored closet doors.",
        "public_id": "019e8479-71a8-718d-ab26-d681dee3cb67",
        "storage_key": "property/6737460151191758/019e8479-71a8-718d-ab26-d681dee3cb67.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, ample closet space with mirrored doors, and a view into the bathroom vanity area.",
      "link": "",
      "alt_text": "Empty bedroom with a ceiling fan and mirrored closet doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c8b1eccc-9de2-4a39-a5b6-54762be23da0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-71b0-7183-8623-e4044e69a068.webp",
      "image_media": {
        "alt_text": "Interior hallway with wood-look flooring and white doors leading to apartments.",
        "public_id": "019e8479-71b0-7183-8623-e4044e69a068",
        "storage_key": "property/6737460151191758/019e8479-71b0-7183-8623-e4044e69a068.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Step into the welcoming interior hallway featuring durable wood-look flooring and access to your private apartment.",
      "link": "",
      "alt_text": "Interior hallway with wood-look flooring and white doors leading to apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0fdd83f0-9a9e-4811-8d98-4a75cfac3d1c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-6e7e-7117-8158-183d68c16caf.webp",
      "image_media": {
        "alt_text": "Dining area with mirror and shelves.",
        "public_id": "019e8479-6e7e-7117-8158-183d68c16caf",
        "storage_key": "property/6737460151191758/019e8479-6e7e-7117-8158-183d68c16caf.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Elegant dining area featuring a large mirror reflecting a ceiling fan and sliding glass doors, complemented by built-in shelves and wood-look flooring.",
      "link": "",
      "alt_text": "Dining area with mirror and shelves.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b133ff62-b7c2-4c95-9c44-57635bd7e204",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-6dce-762d-bdbe-bf9f9169b8c6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark blue cabinets, stainless steel refrigerator, and granite countertops.",
        "public_id": "019e8479-6dce-762d-bdbe-bf9f9169b8c6",
        "storage_key": "property/6737460151191758/019e8479-6dce-762d-bdbe-bf9f9169b8c6.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring sleek dark blue cabinetry, a double basin sink with a gooseneck faucet, and durable granite countertops. Includes a stainless steel refrigerator and dishwasher.",
      "link": "",
      "alt_text": "Modern kitchen with dark blue cabinets, stainless steel refrigerator, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5c1a77aa-f752-4796-9121-7a93bc2ba245",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-6aa1-75dd-a5e0-293bb517b0ee.webp",
      "image_media": {
        "alt_text": "Modern dark blue kitchen cabinets with stainless steel appliances and granite countertops.",
        "public_id": "019e8479-6aa1-75dd-a5e0-293bb517b0ee",
        "storage_key": "property/6737460151191758/019e8479-6aa1-75dd-a5e0-293bb517b0ee.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Explore our stylish kitchens featuring dark blue cabinetry, sleek granite countertops, and modern stainless steel appliances, perfect for your culinary adventures.",
      "link": "",
      "alt_text": "Modern dark blue kitchen cabinets with stainless steel appliances and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_25acd1d5-aed9-4d7b-b24f-192bf19a39c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-5f37-731e-8a79-23581cf396b1.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark blue cabinets, granite countertops, and a stainless steel sink.",
        "public_id": "019e8479-5f37-731e-8a79-23581cf396b1",
        "storage_key": "property/6737460151191758/019e8479-5f37-731e-8a79-23581cf396b1.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "A stylish kitchen featuring dark blue cabinetry, elegant granite countertops, and a deep stainless steel sink with a modern faucet.",
      "link": "",
      "alt_text": "Modern kitchen with dark blue cabinets, granite countertops, and a stainless steel sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9cacfcd8-cc8a-4fe3-8a28-f4a2aa21acfa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-5915-772e-a499-caea1fab17a2.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white subway tile shower, toilet, vanity with granite countertop, and sink.",
        "public_id": "019e8479-5915-772e-a499-caea1fab17a2",
        "storage_key": "property/6737460151191758/019e8479-5915-772e-a499-caea1fab17a2.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Enjoy the clean and modern design of this bathroom, featuring a deep soaking tub with subway tile surround, a granite-topped vanity with a spacious sink, and a stylish navy blue cabinet.",
      "link": "",
      "alt_text": "Modern bathroom with white subway tile shower, toilet, vanity with granite countertop, and sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f1179714-65a1-4001-a6c7-8bfc4dea1529",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-591d-708c-9e34-8f4afbbe956e.webp",
      "image_media": {
        "alt_text": "Hallway with wood-look flooring and doors.",
        "public_id": "019e8479-591d-708c-9e34-8f4afbbe956e",
        "storage_key": "property/6737460151191758/019e8479-591d-708c-9e34-8f4afbbe956e.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Hallway with wood-look flooring and doors, leading to other rooms within the apartment.",
      "link": "",
      "alt_text": "Hallway with wood-look flooring and doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4dfb76bd-2b1b-42e7-aa94-9f15e8af5278",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-5970-72c6-a2a7-bf55267d09d6.webp",
      "image_media": {
        "alt_text": "Interior view of an empty dining area with a door and a light fixture.",
        "public_id": "019e8479-5970-72c6-a2a7-bf55267d09d6",
        "storage_key": "property/6737460151191758/019e8479-5970-72c6-a2a7-bf55267d09d6.webp",
        "width": 1920,
        "height": 1279
      },
      "title": "Apartment",
      "description": "An empty dining area with light gray walls, wood-look flooring, and a white door. Features a modern pendant light fixture and baseboard trim.",
      "link": "",
      "alt_text": "Interior view of an empty dining area with a door and a light fixture.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_69af8a9a-b04e-4d7b-8f51-26265389c089",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-56ac-7239-b1a9-352dc9648bda.webp",
      "image_media": {
        "alt_text": "Interior view of a bedroom with wood-look flooring, a large closet, and a ceiling fan.",
        "public_id": "019e8479-56ac-7239-b1a9-352dc9648bda",
        "storage_key": "property/6737460151191758/019e8479-56ac-7239-b1a9-352dc9648bda.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring elegant wood-look flooring, a large closet for ample storage, and a ceiling fan for comfort. The hallway leads to a well-appointed bathroom.",
      "link": "",
      "alt_text": "Interior view of a bedroom with wood-look flooring, a large closet, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fbf297cf-c0ef-4265-b3af-f301918a14dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-5768-740d-b19a-fac49279df88.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a ceiling fan, window, and closet.",
        "public_id": "019e8479-5768-740d-b19a-fac49279df88",
        "storage_key": "property/6737460151191758/019e8479-5768-740d-b19a-fac49279df88.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Bright and airy bedroom with wood-look flooring, a ceiling fan, and a spacious closet. This versatile room is ready for your personal touch.",
      "link": "",
      "alt_text": "Empty bedroom with a ceiling fan, window, and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9a40786a-8dfc-458a-8116-196310e48588",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-5961-7783-b697-e76f0dc11d08.webp",
      "image_media": {
        "alt_text": "Corner kitchen with navy blue cabinets and granite countertops.",
        "public_id": "019e8479-5961-7783-b697-e76f0dc11d08",
        "storage_key": "property/6737460151191758/019e8479-5961-7783-b697-e76f0dc11d08.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen featuring navy blue cabinets, granite countertops, and a stainless steel sink. The open space allows for a dining area.",
      "link": "",
      "alt_text": "Corner kitchen with navy blue cabinets and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0d8a2840-8a75-42eb-ba15-c8eaaac5e611",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-5718-70f8-bee7-b8ce16139929.webp",
      "image_media": {
        "alt_text": "Empty bedroom with neutral walls, wood-look flooring, and a ceiling fan.",
        "public_id": "019e8479-5718-70f8-bee7-b8ce16139929",
        "storage_key": "property/6737460151191758/019e8479-5718-70f8-bee7-b8ce16139929.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan and ample natural light from two windows. The neutral color palette and wood-look flooring create a versatile and inviting space.",
      "link": "",
      "alt_text": "Empty bedroom with neutral walls, wood-look flooring, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_906f7a6e-e5a7-48b9-bce8-edbc0e105923",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-564d-7671-9288-a0420f359abf.webp",
      "image_media": {
        "alt_text": "Double vanity with granite countertop and dark blue cabinets.",
        "public_id": "019e8479-564d-7671-9288-a0420f359abf",
        "storage_key": "property/6737460151191758/019e8479-564d-7671-9288-a0420f359abf.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Enjoy the convenience of a double vanity with ample storage, perfect for any household.",
      "link": "",
      "alt_text": "Double vanity with granite countertop and dark blue cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cded81f0-8494-49b5-8dba-9a9dd3510d8e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-450a-7449-b306-92c65e81fc3f.webp",
      "image_media": {
        "alt_text": "Aerial view of an apartment complex with a pool and tennis courts.",
        "public_id": "019e8479-450a-7449-b306-92c65e81fc3f",
        "storage_key": "property/6737460151191758/019e8479-450a-7449-b306-92c65e81fc3f.webp",
        "width": 1920,
        "height": 1439
      },
      "title": "Community",
      "description": "Discover resort-style living with our sparkling pool and tennis courts, perfect for relaxation and recreation.",
      "link": "",
      "alt_text": "Aerial view of an apartment complex with a pool and tennis courts.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fe1c3175-2999-47cf-a9e6-70a4dc78e1b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-3f34-76fb-aa67-b46b2e9d6883.webp",
      "image_media": {
        "alt_text": "Living room with sofa, armchair, ottoman, fireplace, and built-in shelving.",
        "public_id": "019e8479-3f34-76fb-aa67-b46b2e9d6883",
        "storage_key": "property/6737460151191758/019e8479-3f34-76fb-aa67-b46b2e9d6883.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Apartment",
      "description": "Relax and unwind in this inviting living room, featuring a cozy fireplace, comfortable seating, and ample storage with elegant built-in shelves.",
      "link": "",
      "alt_text": "Living room with sofa, armchair, ottoman, fireplace, and built-in shelving.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dc9b73ba-5da2-4bca-a5ff-2765b94d096f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-3f35-7726-815a-626c3956db77.webp",
      "image_media": {
        "alt_text": "Dining area with a round white table and four blue velvet chairs.",
        "public_id": "019e8479-3f35-7726-815a-626c3956db77",
        "storage_key": "property/6737460151191758/019e8479-3f35-7726-815a-626c3956db77.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Apartment",
      "description": "Stylish dining area featuring a round white table, plush blue velvet chairs, and modern wall art, perfect for intimate meals.",
      "link": "",
      "alt_text": "Dining area with a round white table and four blue velvet chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e3ab97f6-964e-4615-9ef2-3b81d631ce40",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-3863-710b-a415-0db6dfb10f95.webp",
      "image_media": {
        "alt_text": "Empty living room with hardwood floors, a ceiling fan, and a sliding glass door.",
        "public_id": "019e8479-3863-710b-a415-0db6dfb10f95",
        "storage_key": "property/6737460151191758/019e8479-3863-710b-a415-0db6dfb10f95.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Spacious living area featuring beautiful hardwood floors, a modern ceiling fan, and a sliding glass door that opens to a private balcony or patio.",
      "link": "",
      "alt_text": "Empty living room with hardwood floors, a ceiling fan, and a sliding glass door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_08689dc0-76ae-40c6-9116-7ae2eb33a86d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-3897-7249-83ce-c47f531beab1.webp",
      "image_media": {
        "alt_text": "Empty living room with wood floors, a ceiling fan, sliding glass door, and a white entry door.",
        "public_id": "019e8479-3897-7249-83ce-c47f531beab1",
        "storage_key": "property/6737460151191758/019e8479-3897-7249-83ce-c47f531beab1.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Spacious living area featuring wood-look flooring, a ceiling fan, and access to a patio or balcony through a sliding glass door.",
      "link": "",
      "alt_text": "Empty living room with wood floors, a ceiling fan, sliding glass door, and a white entry door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c1dde5ce-7006-445c-839c-785ed596981a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-3e2a-750b-82c7-fcda13b7b1dd.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and dining area",
        "public_id": "019e8479-3e2a-750b-82c7-fcda13b7b1dd",
        "storage_key": "property/6737460151191758/019e8479-3e2a-750b-82c7-fcda13b7b1dd.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a fireplace, a comfortable sofa, and a separate dining area with blue velvet chairs.",
      "link": "",
      "alt_text": "Living room with fireplace and dining area",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_44ccece4-8b94-4e62-a220-93785eaf4580",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-3897-7249-83ce-c86ae4da32d0.webp",
      "image_media": {
        "alt_text": "Living room and dining area with wood-look floors, white walls, ceiling fan, and pendant light.",
        "public_id": "019e8479-3897-7249-83ce-c86ae4da32d0",
        "storage_key": "property/6737460151191758/019e8479-3897-7249-83ce-c86ae4da32d0.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring wood-look flooring, neutral walls, a ceiling fan for comfort, and elegant pendant lighting. An ideal space for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room and dining area with wood-look floors, white walls, ceiling fan, and pendant light.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a942f07d-172b-4349-ab06-e88f6389f7df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-3f34-76fb-aa67-b1cb0b928c23.webp",
      "image_media": {
        "alt_text": "Open closet with shelving in apartment bathroom",
        "public_id": "019e8479-3f34-76fb-aa67-b1cb0b928c23",
        "storage_key": "property/6737460151191758/019e8479-3f34-76fb-aa67-b1cb0b928c23.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious closet with built-in shelving, perfect for storage, located within the apartment bathroom.",
      "link": "",
      "alt_text": "Open closet with shelving in apartment bathroom",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5063914e-5d4b-4e46-89c3-28613ff5faeb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019e8479-3f35-7726-815a-5fda08c1abf8.webp",
      "image_media": {
        "alt_text": "Modern bathroom with toilet and shower/tub combo.",
        "public_id": "019e8479-3f35-7726-815a-5fda08c1abf8",
        "storage_key": "property/6737460151191758/019e8479-3f35-7726-815a-5fda08c1abf8.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Step into this bright and clean bathroom, featuring a stylish toilet and a relaxing shower/tub combo. Perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Modern bathroom with toilet and shower/tub combo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_05b727c9-68bc-4402-8b4a-7368dca4736b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076d-b342-7093-994c-152093961120.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and adjacent kitchen area.",
        "public_id": "019d076d-b342-7093-994c-152093961120",
        "storage_key": "property/6737460151191758/019d076d-b342-7093-994c-152093961120.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a cozy fireplace and a modern kitchen with dark cabinetry, perfect for entertaining.",
      "link": "",
      "alt_text": "Living room with fireplace and adjacent kitchen area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3485042e-c177-4efc-a96d-c767873c571d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076d-aab4-73da-ac4d-114707a203f5.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark blue cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019d076d-aab4-73da-ac4d-114707a203f5",
        "storage_key": "property/6737460151191758/019d076d-aab4-73da-ac4d-114707a203f5.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring dark blue cabinetry, sleek granite countertops, and stainless steel appliances. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with dark blue cabinets, granite countertops, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_b0ec2b26-5ef8-46c4-8c15-c514ff52d780",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "2970 N Lake Pkwy, Columbus, GA 31909, USA",
      "poi_short_description": "Chain eatery specializing in steaks (including slow-cooked prime rib) and fall-off-the-bone ribs, plus signature margaritas.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and catfish, and the rolls with cinnamon butter are a favorite. They also highlight the fast service, friendly staff, and attentive servers.\n\nSome reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076d-eab8-7448-b8eb-e4e8f3e6dadd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076d-eab8-7448-b8eb-e4e8f3e6dadd",
        "storage_key": "property/6737460151191758/019d076d-eab8-7448-b8eb-e4e8f3e6dadd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/georgia/columbus?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=10936079681892073598&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "32.5513552",
      "poi_longitude": "-84.94735419999999",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 706-323-6616",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-3087-74bd-af08-27cacaa1d3ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-3087-74bd-af08-27cacaa1d3ae",
        "storage_key": "property/6737460151191758/019d076e-3087-74bd-af08-27cacaa1d3ae.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJty6cUDbLjIgRfkCLYofCxJc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_d99526e1-03a0-4888-aa46-1739db522a81",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "2421 Wynnton Rd, Columbus, GA 31906, USA",
      "poi_short_description": "Chicken chain restaurant, serving nuggets and sandwiches from a counter (or drive-thru window).",
      "poi_long_description": "People say this fast food restaurant offers chicken sandwiches, salads, and sides. They highlight the food is fresh and the mobile ordering is convenient. They also like the friendly staff and quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076d-eb6b-72ae-8364-7c77bde80a25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076d-eb6b-72ae-8364-7c77bde80a25",
        "storage_key": "property/6737460151191758/019d076d-eb6b-72ae-8364-7c77bde80a25.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ga/macon-road?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=12359070794567881533&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "32.4720143",
      "poi_longitude": "-84.9562715",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 706-321-5880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-3087-74bd-af08-27cacaa1d3ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-3087-74bd-af08-27cacaa1d3ae",
        "storage_key": "property/6737460151191758/019d076e-3087-74bd-af08-27cacaa1d3ae.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpwBpZiPNjIgRPZMfEGg9hKs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_766f81df-76ef-419d-a64f-bbd292149e4f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Hibachi Grill & Supreme Buffet",
      "poi_type": "Restaurants",
      "poi_address": "2040 Auburn Ave, Columbus, GA 31906, USA",
      "poi_short_description": "Popular buffet restaurant serving Chinese eats alongside sushi.",
      "poi_long_description": "People say this Japanese restaurant offers a large buffet with a wide variety of fresh food, including sushi, hibachi, and Chinese dishes. They also highlight the friendly and attentive service, and the clean and spacious atmosphere.\n\nOther reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076d-eace-7008-80fa-b90cb7a5e5a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076d-eace-7008-80fa-b90cb7a5e5a2",
        "storage_key": "property/6737460151191758/019d076d-eace-7008-80fa-b90cb7a5e5a2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10405209400130421435&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "hibachi-grill--supreme-buffet",
      "poi_latitude": "32.4820752",
      "poi_longitude": "-84.9448506",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 706-568-6889",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-3087-74bd-af08-27cacaa1d3ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-3087-74bd-af08-27cacaa1d3ae",
        "storage_key": "property/6737460151191758/019d076e-3087-74bd-af08-27cacaa1d3ae.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDbNYGtbMjIgRu0JU_NG6ZpA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_0a800296-20ca-4e31-991c-36de7166b064",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Stars and Strikes",
      "poi_type": "Restaurants",
      "poi_address": "7607 Veterans Pkwy, Columbus, GA 31909, USA",
      "poi_short_description": "Family-friendly entertainment center featuring bowling, laser tag, arcade games and a restaurant.",
      "poi_long_description": "People say this restaurant offers a variety of activities, including bowling, laser tag, and arcade games, and serves good drinks. They also highlight the fun, family-friendly vibe and the friendly, helpful staff.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076d-ea7d-71ab-afba-45724f335668.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076d-ea7d-71ab-afba-45724f335668",
        "storage_key": "property/6737460151191758/019d076d-ea7d-71ab-afba-45724f335668.webp",
        "width": 603,
        "height": 340
      },
      "poi_business_url": "https://starsandstrikes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14963100533999672322&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "stars-and-strikes",
      "poi_latitude": "32.5584632",
      "poi_longitude": "-84.9443933",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 678-965-5707",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-3087-74bd-af08-27cacaa1d3ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-3087-74bd-af08-27cacaa1d3ae",
        "storage_key": "property/6737460151191758/019d076e-3087-74bd-af08-27cacaa1d3ae.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjWh-OTLLjIgRAhyCY6icp88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_1550b0cb-83e7-4173-9684-dbfd5500040c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Cracker Barrel Old Country Store",
      "poi_type": "Restaurants",
      "poi_address": "1500 Bradley Park Dr, Columbus, GA 31904, USA",
      "poi_short_description": "Homestyle American cooking such as pancakes and fried chicken, plus a gift shop.",
      "poi_long_description": "People say this American restaurant serves delicious biscuits, cornbread, and country fried steak. They also highlight the fresh food, friendly staff, and the gift shop.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076d-f094-71a1-9cad-b73e2d75ff7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076d-f094-71a1-9cad-b73e2d75ff7f",
        "storage_key": "property/6737460151191758/019d076d-f094-71a1-9cad-b73e2d75ff7f.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.crackerbarrel.com/Locations/States/ga/columbus/523/?utm_source=google&utm_medium=maps&utm_campaign=crackerbarrelurl",
      "poi_directions_map_url": "https://maps.google.com/?cid=14620582822865788649&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "cracker-barrel-old-country-store",
      "poi_latitude": "32.53111",
      "poi_longitude": "-84.9711061",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 706-317-3460",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-3087-74bd-af08-27cacaa1d3ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-3087-74bd-af08-27cacaa1d3ae",
        "storage_key": "property/6737460151191758/019d076e-3087-74bd-af08-27cacaa1d3ae.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7TrgJn3LjIgR6d4XPp2-5so",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_34aa7d61-63cf-4b36-a568-5d99ea30e416",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Peachtree Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "3131 Manchester Expy, Columbus, GA 31909, USA",
      "poi_short_description": "Popular shopping center featuring major retailers, a food court and a playground.",
      "poi_long_description": "People say this shopping center is exceptionally clean with a variety of stores and restaurants, offering great food at affordable prices. They also highlight the respectful and courteous atmosphere, making it a perfect place for shopping and dining.\n\nSome reviews mention the mall can be unpopular.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076d-f0c1-7389-8842-dcf850a5ddbb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076d-f0c1-7389-8842-dcf850a5ddbb",
        "storage_key": "property/6737460151191758/019d076d-f0c1-7389-8842-dcf850a5ddbb.webp",
        "width": 600,
        "height": 337
      },
      "poi_business_url": "https://www.peachtreemall.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=13036472431641578737&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "peachtree-mall",
      "poi_latitude": "32.5092189",
      "poi_longitude": "-84.9422979",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 706-327-1598",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-308e-7418-96f4-a166d06f1980.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-308e-7418-96f4-a166d06f1980",
        "storage_key": "property/6737460151191758/019d076e-308e-7418-96f4-a166d06f1980.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJdebs0LXMjIgR8UwrPJva6rQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_afa6cfed-6eaf-4a14-9b13-4023a1768b3c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "2891 Sowega Dr, Columbus, GA 31909, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store has helpful and friendly staff, and is well-stocked with a wide variety of items for DIY projects, including Ryobi tools and accessories. They also highlight the knowledgeable staff and the convenient app that accurately reflects in-store inventory.\n\nSome reviews mention the wait times for assistance can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076d-f1ad-712b-8b31-69b58643d890.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076d-f1ad-712b-8b31-69b58643d890",
        "storage_key": "property/6737460151191758/019d076d-f1ad-712b-8b31-69b58643d890.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.homedepot.com/l/Columbus/GA/Columbus/31909/136?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8620935738034352132&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "32.5248582",
      "poi_longitude": "-84.9490639",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 706-322-9240",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-308e-7418-96f4-a166d06f1980.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-308e-7418-96f4-a166d06f1980",
        "storage_key": "property/6737460151191758/019d076e-308e-7418-96f4-a166d06f1980.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJA0gGiqjMjIgRBPAByWC3o3c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_5188d48e-96cc-4039-92ae-5562b9e4bd22",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "6750 Veterans Pkwy, Columbus, GA 31909, USA",
      "poi_short_description": "Supply chain selling tools, appliances, paint and garden items.",
      "poi_long_description": "People say this home improvement store offers a wide selection of useful items for DIY projects, lawn care, and mechanical maintenance. They also highlight the helpful and friendly staff, and the military discount.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076d-f1af-7118-8124-b46673a3611b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076d-f1af-7118-8124-b46673a3611b",
        "storage_key": "property/6737460151191758/019d076d-f1af-7118-8124-b46673a3611b.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/GA-Columbus/0636?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-636-_-na-_-0-_-0&y_source=1_MTE4Mzg1MC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=7685055275613954274&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "32.541464",
      "poi_longitude": "-84.95209299999999",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 706-320-9292",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-308e-7418-96f4-a166d06f1980.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-308e-7418-96f4-a166d06f1980",
        "storage_key": "property/6737460151191758/019d076e-308e-7418-96f4-a166d06f1980.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ9W6yAEXLjIgR4iA2Vg7Npmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_f086421e-7bb3-4d0b-9941-b43e29af2be4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Publix Super Market at Cross Country Plaza",
      "poi_type": "Shopping & Retail",
      "poi_address": "3201 Macon Rd Ste 201, Columbus, GA 31906, USA",
      "poi_short_description": "Supermarket chain offering a seafood section, hot deli, bakery, butcher shop and produce items.",
      "poi_long_description": "People say this supermarket offers a wide variety of fresh produce, meats, and pantry items, as well as delicious sub sandwiches and birthday cakes. They highlight the clean and organized store, and the friendly and helpful staff. They also like the good deals and fresh food.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076d-f749-765e-a31b-6df75a898be0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076d-f749-765e-a31b-6df75a898be0",
        "storage_key": "property/6737460151191758/019d076d-f749-765e-a31b-6df75a898be0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1390&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=14960460928790668815&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "publix-super-market-at-cross-country-plaza",
      "poi_latitude": "32.4827089",
      "poi_longitude": "-84.9443847",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 706-561-2160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-3092-72f8-be9d-a5588ad60181.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-3092-72f8-be9d-a5588ad60181",
        "storage_key": "property/6737460151191758/019d076e-3092-72f8-be9d-a5588ad60181.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv4fQbyrNjIgRD6ataPM7ns8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_b4c2e640-6290-4d3a-b7a3-4cd9cd98585c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Publix Super Market at Bradley Park Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "1639 Bradley Park Dr Ste 600, Columbus, GA 31904, USA",
      "poi_short_description": "Supermarket featuring an in-house bakery and deli, plus a seafood counter and pharmacy.",
      "poi_long_description": "People say this supermarket offers a wide variety of fresh produce and groceries. They highlight the clean store, convenient parking, and quick checkout. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076d-f6b1-7677-a322-82c837c887d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076d-f6b1-7677-a322-82c837c887d5",
        "storage_key": "property/6737460151191758/019d076d-f6b1-7677-a322-82c837c887d5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=474&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=577787667819581684&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "publix-super-market-at-bradley-park-square",
      "poi_latitude": "32.5343227",
      "poi_longitude": "-84.9668462",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 706-571-3420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-3092-72f8-be9d-a5588ad60181.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-3092-72f8-be9d-a5588ad60181",
        "storage_key": "property/6737460151191758/019d076e-3092-72f8-be9d-a5588ad60181.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsSbWG2TLjIgR9ND8l9K2BAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_b646f31a-aaf5-4ec6-9627-429c788c3834",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Columbus State University",
      "poi_type": "Education",
      "poi_address": "4225 University Ave, Columbus, GA 31907, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076d-f8d2-77d7-a933-5e52611eccd9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076d-f8d2-77d7-a933-5e52611eccd9",
        "storage_key": "property/6737460151191758/019d076d-f8d2-77d7-a933-5e52611eccd9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.columbusstate.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11762932347257431958&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "columbus-state-university",
      "poi_latitude": "32.5023061",
      "poi_longitude": "-84.9396502",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 706-507-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-308a-77bd-b378-9e3bb2c26e74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-308a-77bd-b378-9e3bb2c26e74",
        "storage_key": "property/6737460151191758/019d076e-308a-77bd-b378-9e3bb2c26e74.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ63XOMJbNjIgRlic7q6VUPqM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_08a9f980-0b7f-41ae-bc23-b26e4d7796fa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Columbus Public Library",
      "poi_type": "Education",
      "poi_address": "3000 Macon Rd, Columbus, GA 31906, USA",
      "poi_short_description": "Books, computers, meeting rooms, and a children's garden are features of this public library.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076d-f8fc-72cb-845e-ae83370e2d6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076d-f8fc-72cb-845e-ae83370e2d6a",
        "storage_key": "property/6737460151191758/019d076d-f8fc-72cb-845e-ae83370e2d6a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.cvlga.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15686806498958077764&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "columbus-public-library",
      "poi_latitude": "32.4769285",
      "poi_longitude": "-84.9441159",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 706-243-2669",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-308a-77bd-b378-9e3bb2c26e74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-308a-77bd-b378-9e3bb2c26e74",
        "storage_key": "property/6737460151191758/019d076e-308a-77bd-b378-9e3bb2c26e74.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcb616ivNjIgRRG-vBma7stk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_698e578d-3add-4b4d-922e-717166dcb062",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Columbus Technical College",
      "poi_type": "Education",
      "poi_address": "928 Manchester Expy, Columbus, GA 31904, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076d-fc78-7748-8715-3d702dcbbdb8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076d-fc78-7748-8715-3d702dcbbdb8",
        "storage_key": "property/6737460151191758/019d076d-fc78-7748-8715-3d702dcbbdb8.webp",
        "width": 400,
        "height": 267
      },
      "poi_business_url": "http://www.columbustech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5450111125390431484&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "columbus-technical-college",
      "poi_latitude": "32.5081062",
      "poi_longitude": "-84.978495",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 706-649-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-308a-77bd-b378-9e3bb2c26e74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-308a-77bd-b378-9e3bb2c26e74",
        "storage_key": "property/6737460151191758/019d076e-308a-77bd-b378-9e3bb2c26e74.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYdc_xYrMjIgR_BRNTzGvoks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_74628c35-0110-4c26-8ffc-afef5a47fbda",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "St. Anne-Pacelli Catholic School",
      "poi_type": "Education",
      "poi_address": "2020 Kay Cir, Columbus, GA 31907, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076d-fdb5-746b-842c-d3cb4c240212.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076d-fdb5-746b-842c-d3cb4c240212",
        "storage_key": "property/6737460151191758/019d076d-fdb5-746b-842c-d3cb4c240212.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.beaviking.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12274786306817376648&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "st-anne-pacelli-catholic-school",
      "poi_latitude": "32.4824202",
      "poi_longitude": "-84.93407169999999",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 706-561-8232",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-308a-77bd-b378-9e3bb2c26e74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-308a-77bd-b378-9e3bb2c26e74",
        "storage_key": "property/6737460151191758/019d076e-308a-77bd-b378-9e3bb2c26e74.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO_hUbCoz84gRiMGthxzNWKo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_af80fa04-9cc0-448f-abb8-7810e806bdc5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "1627 Bradley Park Dr Suite 1, Columbus, GA 31904, USA",
      "poi_short_description": "Airy, family-friendly venue for birthday parties featuring trampolines, obstacle courses, laser tag and more.",
      "poi_long_description": "People say this amusement park offers a wide variety of fun activities for kids and families. They also highlight the clean facility, helpful staff, and attentive management.\n\nSome reviews mention the socks can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076d-ff8f-736e-bff6-e0eab2512070.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076d-ff8f-736e-bff6-e0eab2512070",
        "storage_key": "property/6737460151191758/019d076d-ff8f-736e-bff6-e0eab2512070.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.urbanair.com/georgia-columbus/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=8985776566520304968&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "32.5341428",
      "poi_longitude": "-84.9682456",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 706-341-1124",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-351d-703e-b532-4f86698e3ca6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-351d-703e-b532-4f86698e3ca6",
        "storage_key": "property/6737460151191758/019d076e-351d-703e-b532-4f86698e3ca6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeehh4e7LjIgRSNV4ti3ks3w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_bb11b7f5-26f5-44b3-b776-5526f818e4b5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Sky Zone Trampoline Park",
      "poi_type": "Entertainment",
      "poi_address": "3716 Gentian Blvd Suite B, Columbus, GA 31907, USA",
      "poi_short_description": "Indoor activity center with a trampoline park, a playground, and a restaurant, plus massage chairs.",
      "poi_long_description": "Chain of indoor trampoline parks featuring freestyle bouncing, dodgeball, fitness programs & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-0099-7602-a82b-1db068f31e46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076e-0099-7602-a82b-1db068f31e46",
        "storage_key": "property/6737460151191758/019d076e-0099-7602-a82b-1db068f31e46.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.skyzone.com/columbus-ga/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7782543368094508075&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "sky-zone-trampoline-park",
      "poi_latitude": "32.5065778",
      "poi_longitude": "-84.9324931",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 762-253-3854",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-351d-703e-b532-4f86698e3ca6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-351d-703e-b532-4f86698e3ca6",
        "storage_key": "property/6737460151191758/019d076e-351d-703e-b532-4f86698e3ca6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIRvkWegz84gRK2RYqPUlAWw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_8671f65e-abac-4217-9b23-d2708330fd9a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Kinnett Stadium",
      "poi_type": "Entertainment",
      "poi_address": "7610 N Stadium Dr, Columbus, GA 31909, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-0369-70ec-8c18-ae4a20b21d2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076e-0369-70ec-8c18-ae4a20b21d2e",
        "storage_key": "property/6737460151191758/019d076e-0369-70ec-8c18-ae4a20b21d2e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stadiumconnection.com/ga/stadium.php?id=4515",
      "poi_directions_map_url": "https://maps.google.com/?cid=18117927228565128045&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "kinnett-stadium",
      "poi_latitude": "32.5593162",
      "poi_longitude": "-84.90625829999999",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-353a-771b-a9bf-c35cdef2c962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-353a-771b-a9bf-c35cdef2c962",
        "storage_key": "property/6737460151191758/019d076e-353a-771b-a9bf-c35cdef2c962.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG8jMJxo184gRbYMATdLOb_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_4a2a0110-1aed-4625-9b1c-a1cf4f80cd34",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Columbus Collective Museums",
      "poi_type": "Entertainment",
      "poi_address": "3218 Hamilton Rd, Columbus, GA 31904, USA",
      "poi_short_description": "Nonprofit collection of 7 museums spotlighting items such as lunchboxes, peanuts, and vintage cars.",
      "poi_long_description": "Visitors say this museum features an impressive collection of antiques, including lunchboxes, Royal Crown Cola memorabilia, and classic cars, and they praise the friendly and knowledgeable staff. They also highlight the nostalgic atmosphere and the opportunity to learn about local history.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-0419-74e9-a981-7f845b55f7eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076e-0419-74e9-a981-7f845b55f7eb",
        "storage_key": "property/6737460151191758/019d076e-0419-74e9-a981-7f845b55f7eb.webp",
        "width": 1050,
        "height": 600
      },
      "poi_business_url": "https://www.columbuscollectivemuseums.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9783342105142463660&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "columbus-collective-museums",
      "poi_latitude": "32.4943738",
      "poi_longitude": "-84.9795731",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 706-332-6378",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-355d-715c-a57c-9b62789b3c31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-355d-715c-a57c-9b62789b3c31",
        "storage_key": "property/6737460151191758/019d076e-355d-715c-a57c-9b62789b3c31.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1xnU93bNjIgRrIwjbc9pxYc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_f33add78-a688-47e1-8a1a-57664be39d29",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Frank G. Lumpkin Jr. Center",
      "poi_type": "Entertainment",
      "poi_address": "4225 University Ave, Columbus, GA 31907, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-061f-770e-9de9-3cfc5131410c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076e-061f-770e-9de9-3cfc5131410c",
        "storage_key": "property/6737460151191758/019d076e-061f-770e-9de9-3cfc5131410c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://csucougars.com/facilities/frank-g-lumpkin-jr-center/1",
      "poi_directions_map_url": "https://maps.google.com/?cid=11872881619004979563&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "frank-g-lumpkin-jr-center",
      "poi_latitude": "32.5043615",
      "poi_longitude": "-84.94017769999999",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 706-569-3198",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-351d-703e-b532-4f86698e3ca6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-351d-703e-b532-4f86698e3ca6",
        "storage_key": "property/6737460151191758/019d076e-351d-703e-b532-4f86698e3ca6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhbidUrXMjIgRa3kOYe3yxKQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_e7fac043-d073-47b0-af63-ab14ceb2809b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Crunch Fitness - Columbus",
      "poi_type": "Health and Wellness",
      "poi_address": "2925 Manchester Expy, Columbus, GA 31909, USA",
      "poi_short_description": "Gym offering classes, cardio machines, weights, personal training, a sauna, and a tanning bed.",
      "poi_long_description": "Visitors say this gym has a spacious layout with a wide variety of well-maintained equipment, including free weights, and a sauna. They also highlight the friendly and helpful staff, and the clean facilities.\n\nSome reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-0742-72bb-b336-813d235621ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076e-0742-72bb-b336-813d235621ca",
        "storage_key": "property/6737460151191758/019d076e-0742-72bb-b336-813d235621ca.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://www.crunch.com/locations/columbus",
      "poi_directions_map_url": "https://maps.google.com/?cid=1342247627727725242&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "crunch-fitness---columbus",
      "poi_latitude": "32.506984",
      "poi_longitude": "-84.9475155",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 706-940-3899",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-351d-703e-b532-4f86698e3ca6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-351d-703e-b532-4f86698e3ca6",
        "storage_key": "property/6737460151191758/019d076e-351d-703e-b532-4f86698e3ca6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOb0VoCPNjIgRumJSGxufoBI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6525e183-e28b-4f93-889e-c63ad37a1f30",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "5596 Milgen Rd #300, Columbus, GA 31907, USA",
      "poi_short_description": "Membership-only chain providing a variety of fitness equipment such as tanning beds, plus massages.",
      "poi_long_description": "People say this gym is clean and well-maintained. They highlight the happy and welcoming atmosphere, and the friendly and helpful staff. They also like the convenient water fountain.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-0943-7578-a507-329116ebff1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076e-0943-7578-a507-329116ebff1b",
        "storage_key": "property/6737460151191758/019d076e-0943-7578-a507-329116ebff1b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/columbus-milgen-rd-ga?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=14925372502216082521&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "32.5195095",
      "poi_longitude": "-84.8909932",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 706-568-8834",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-351d-703e-b532-4f86698e3ca6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-351d-703e-b532-4f86698e3ca6",
        "storage_key": "property/6737460151191758/019d076e-351d-703e-b532-4f86698e3ca6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdQTjQYYz84gRWQT5djaTIc8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ff0a4d8f-c4cb-4cf3-a9d7-d93721f1b847",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "D.A. Turner Branch YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "4384 Warm Springs Rd, Columbus, GA 31909, USA",
      "poi_short_description": "Gym offering exercise rooms, group classes, a swimming pool, and basketball and volleyball courts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-0cf4-7669-b0a9-1e6dfcfed454.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076e-0cf4-7669-b0a9-1e6dfcfed454",
        "storage_key": "property/6737460151191758/019d076e-0cf4-7669-b0a9-1e6dfcfed454.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.ymcacolumbusga.com/da-turner-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=10466684262257806675&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "da-turner-branch-ymca",
      "poi_latitude": "32.5184554",
      "poi_longitude": "-84.91811659999999",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 706-563-7001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-351d-703e-b532-4f86698e3ca6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-351d-703e-b532-4f86698e3ca6",
        "storage_key": "property/6737460151191758/019d076e-351d-703e-b532-4f86698e3ca6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJne1dQGcz84gRU00MtOEhQZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0b5a199d-b5aa-48b7-b04e-0db37c1511d8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Bladez 2.0 Barbershop",
      "poi_type": "Health and Wellness",
      "poi_address": "2497 Airport Thruway, Columbus, GA 31904, USA",
      "poi_short_description": "Kid-friendly barbershop specializing in haircuts and grooming services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-0da8-73bd-a265-0645425e521c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076e-0da8-73bd-a265-0645425e521c",
        "storage_key": "property/6737460151191758/019d076e-0da8-73bd-a265-0645425e521c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://online.getsquire.com/book/bladez-2-0-barbershop-georgia-columbus/professional",
      "poi_directions_map_url": "https://maps.google.com/?cid=5424931193494285630&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "bladez-20-barbershop",
      "poi_latitude": "32.5213918",
      "poi_longitude": "-84.95678219999999",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 706-221-3902",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-351d-703e-b532-4f86698e3ca6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-351d-703e-b532-4f86698e3ca6",
        "storage_key": "property/6737460151191758/019d076e-351d-703e-b532-4f86698e3ca6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCV-YDufNjIgRPq0pjy06SUs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_a81c3e61-c630-4034-80d7-52e891575e66",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Gymnastics Unlimited",
      "poi_type": "Health and Wellness",
      "poi_address": "4368 Warm Springs Rd, Columbus, GA 31909, USA",
      "poi_short_description": "Gymnastics center providing classes and training for kids ages 3-18.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-0ee1-77d0-8101-65cc95d3141f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076e-0ee1-77d0-8101-65cc95d3141f",
        "storage_key": "property/6737460151191758/019d076e-0ee1-77d0-8101-65cc95d3141f.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.gymunlimitedga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16275544978647668197&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "gymnastics-unlimited",
      "poi_latitude": "32.5167682",
      "poi_longitude": "-84.91870159999999",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 706-563-1866",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-308a-77bd-b378-9e3bb2c26e74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-308a-77bd-b378-9e3bb2c26e74",
        "storage_key": "property/6737460151191758/019d076e-308a-77bd-b378-9e3bb2c26e74.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO-Hz21wz84gR5dUvMu1Z3uE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_67a25e90-ce88-4c14-8919-a54180498bd4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Tips N Toes Nail Salon",
      "poi_type": "Health and Wellness",
      "poi_address": "5295 Whittlesey Blvd #200, Columbus, GA 31909, USA",
      "poi_short_description": "Unpretentious salon providing manicures and pedicures as well as waxing services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-0f5d-773d-893e-546a2b8e09db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076e-0f5d-773d-893e-546a2b8e09db",
        "storage_key": "property/6737460151191758/019d076e-0f5d-773d-893e-546a2b8e09db.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.facebook.com/profile.php?id=100054276771111&mibextid=ZbWKwL",
      "poi_directions_map_url": "https://maps.google.com/?cid=1225734532673089016&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "tips-n-toes-nail-salon",
      "poi_latitude": "32.5416267",
      "poi_longitude": "-84.9505157",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 706-649-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-351d-703e-b532-4f86698e3ca6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-351d-703e-b532-4f86698e3ca6",
        "storage_key": "property/6737460151191758/019d076e-351d-703e-b532-4f86698e3ca6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzQhDYk_LjIgR-K3oMBCvAhE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_228ac076-c98a-4c0b-8dae-739f0a832d3a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "FITLIFE Columbus",
      "poi_type": "Health and Wellness",
      "poi_address": "3049 Tower Rd, Columbus, GA 31909, USA",
      "poi_short_description": "Family-friendly gym featuring spin and push classes, plus childcare and personal training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-1377-778c-80c8-76b384c9bf1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076e-1377-778c-80c8-76b384c9bf1d",
        "storage_key": "property/6737460151191758/019d076e-1377-778c-80c8-76b384c9bf1d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.fitlifehc.com/locations/columbus",
      "poi_directions_map_url": "https://maps.google.com/?cid=14016218870119783864&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "fitlife-columbus",
      "poi_latitude": "32.5609002",
      "poi_longitude": "-84.94082209999999",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 706-653-1444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-351d-703e-b532-4f86698e3ca6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-351d-703e-b532-4f86698e3ca6",
        "storage_key": "property/6737460151191758/019d076e-351d-703e-b532-4f86698e3ca6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ30clWi3LjIgRuN2dH82cg8I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e0bce74e-d0f0-443f-87cc-7a875d85905b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Affordable Veterinary Services",
      "poi_type": "Health and Wellness",
      "poi_address": "7660 Kayne Blvd, Columbus, GA 31909, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-13db-75fc-b746-48a405cec939.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076e-13db-75fc-b746-48a405cec939",
        "storage_key": "property/6737460151191758/019d076e-13db-75fc-b746-48a405cec939.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://affordablevetservices.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=717021697831179614&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "affordable-veterinary-services",
      "poi_latitude": "32.5560235",
      "poi_longitude": "-84.94121679999999",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 706-221-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-351d-703e-b532-4f86698e3ca6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-351d-703e-b532-4f86698e3ca6",
        "storage_key": "property/6737460151191758/019d076e-351d-703e-b532-4f86698e3ca6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT-Zq_zLLjIgRXpV5a29f8wk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_0be0c019-d8b0-4031-b0d3-4f5ab5fb1e92",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "The Nappy Root Barber Shop",
      "poi_type": "Health and Wellness",
      "poi_address": "The Nappy Root Barber Shop, 4231 Macon Rd #40, Columbus, GA 31907, USA",
      "poi_short_description": "Casual barber shop (voted “best” locally) specializing in all-clipper haircuts for men, women and kids, as well as shaves.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-1726-767c-ba54-a643088aaac8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076e-1726-767c-ba54-a643088aaac8",
        "storage_key": "property/6737460151191758/019d076e-1726-767c-ba54-a643088aaac8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6689908660608705516&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "the-nappy-root-barber-shop",
      "poi_latitude": "32.4912948",
      "poi_longitude": "-84.9194717",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 706-221-3973",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-351d-703e-b532-4f86698e3ca6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-351d-703e-b532-4f86698e3ca6",
        "storage_key": "property/6737460151191758/019d076e-351d-703e-b532-4f86698e3ca6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbzw_piIz84gR7CNkb3tU11w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_d4c35327-764f-41eb-a546-98f3bca6707f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "St. Francis-Emory Healthcare",
      "poi_type": "Health and Wellness",
      "poi_address": "2122 Manchester Expy, Columbus, GA 31904, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-165e-76ae-b930-1c7e2a48ed02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076e-165e-76ae-b930-1c7e2a48ed02",
        "storage_key": "property/6737460151191758/019d076e-165e-76ae-b930-1c7e2a48ed02.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.mystfrancis.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2278130719390853277&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "st-francis-emory-healthcare",
      "poi_latitude": "32.5056341",
      "poi_longitude": "-84.9606883",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 706-596-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-355d-715c-a57c-96de6fcd877f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-355d-715c-a57c-96de6fcd877f",
        "storage_key": "property/6737460151191758/019d076e-355d-715c-a57c-96de6fcd877f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJxx4P77_MjIgRnWgyudGLnR8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_b0c5e9f0-5b73-4f46-9fbe-e5ba2d532bdb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Piedmont Columbus Regional - Northside",
      "poi_type": "Health and Wellness",
      "poi_address": "100 Frist Ct, Columbus, GA 31909, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-19cc-717f-8054-88de3c21142e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076e-19cc-717f-8054-88de3c21142e",
        "storage_key": "property/6737460151191758/019d076e-19cc-717f-8054-88de3c21142e.webp",
        "width": 1280,
        "height": 795
      },
      "poi_business_url": "https://www.piedmont.org/locations/piedmont-columbus/about?utm_source=directorylisting&utm_medium=seo&utm_campaign=10223&y_source=1_MTI5OTcwMTItNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=14897132902326719056&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "piedmont-columbus-regional---northside",
      "poi_latitude": "32.534573",
      "poi_longitude": "-84.951173",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 706-494-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-355d-715c-a57c-96de6fcd877f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-355d-715c-a57c-96de6fcd877f",
        "storage_key": "property/6737460151191758/019d076e-355d-715c-a57c-96de6fcd877f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJU_E0e1rLjIgRUNL3PnI_vc4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_0f25e366-0206-43fd-aef3-fd4878306711",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Flat Rock Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6106 Warm Springs Rd, Columbus, GA 31909, USA",
      "poi_short_description": "Expansive park featuring rock formations and a playground.",
      "poi_long_description": "People say this park offers a disc golf course, hiking trails, fishing spots, and a creek with rocks for playing and relaxing. They highlight the park's natural beauty, peaceful atmosphere, and spaciousness, making it ideal for picnics, walks, and enjoying nature. They also like the availability of picnic areas with grills and the fun playground for children.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-1a4d-76fc-b1ec-6e45e502f9d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076e-1a4d-76fc-b1ec-6e45e502f9d3",
        "storage_key": "property/6737460151191758/019d076e-1a4d-76fc-b1ec-6e45e502f9d3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://parks.columbusga.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6020222500879091986&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "flat-rock-park",
      "poi_latitude": "32.54283060000001",
      "poi_longitude": "-84.88263189999999",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 706-225-4658",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-39bf-73ae-9109-1bbb7f9858a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-39bf-73ae-9109-1bbb7f9858a4",
        "storage_key": "property/6737460151191758/019d076e-39bf-73ae-9109-1bbb7f9858a4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJW0g_XCnNjIgREkm20XcgjFM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f43f4453-14e3-43ba-a438-6f21e401e4f6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Cooper Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5089 Cooper Creek Road,, Columbus, GA 31907, USA",
      "poi_short_description": "Popular lakefront park with hiking trails and a playground for kids.",
      "poi_long_description": "People say this park offers peaceful walking trails and picnic areas. They also highlight the tranquil vibe and opportunities to observe nature.\n\nOther reviews mention the park can be messy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-1d4d-76ad-bfe6-b4ab01bf72fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076e-1d4d-76ad-bfe6-b4ab01bf72fe",
        "storage_key": "property/6737460151191758/019d076e-1d4d-76ad-bfe6-b4ab01bf72fe.webp",
        "width": 348,
        "height": 348
      },
      "poi_business_url": "https://parks.columbusga.gov/parks/Cooper-Creek-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=10696366737007449057&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "cooper-creek-park",
      "poi_latitude": "32.5143662",
      "poi_longitude": "-84.9117172",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 706-225-4658",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-39bf-73ae-9109-1bbb7f9858a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-39bf-73ae-9109-1bbb7f9858a4",
        "storage_key": "property/6737460151191758/019d076e-39bf-73ae-9109-1bbb7f9858a4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4bZM1m4z84gR4ROiIuAgcZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f152358b-f3a8-42f0-a387-66d661d4e395",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Bull Creek Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7333 Lynch Rd, Midland, GA 31820, USA",
      "poi_short_description": "Well-maintained public golf course with affordable rates.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-1e55-7134-82a7-8a36d4713e39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076e-1e55-7134-82a7-8a36d4713e39",
        "storage_key": "property/6737460151191758/019d076e-1e55-7134-82a7-8a36d4713e39.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.columbusga.org/bullcreek/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15775751074573752092&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "bull-creek-golf-course",
      "poi_latitude": "32.5501251",
      "poi_longitude": "-84.8419189",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 706-561-1614",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-39c5-7561-975a-f422f801fb51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-39c5-7561-975a-f422f801fb51",
        "storage_key": "property/6737460151191758/019d076e-39c5-7561-975a-f422f801fb51.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJZRZkqZY284gRHJf00AS67to",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_a1880c01-27ea-41a5-8587-04ff592d4b69",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Lakebottom Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1505 Cherokee Ave, Columbus, GA 31901, USA",
      "poi_short_description": "Leafy public park featuring a manmade creek & amenities such as a playground & athletic fields.",
      "poi_long_description": "People say this park is a good place to walk. They highlight the walking trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-21c8-732a-a0e2-ce4af5122b55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076e-21c8-732a-a0e2-ce4af5122b55",
        "storage_key": "property/6737460151191758/019d076e-21c8-732a-a0e2-ce4af5122b55.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13084752654494122639&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "lakebottom-park",
      "poi_latitude": "32.4759141",
      "poi_longitude": "-84.96597899999999",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 706-653-4189",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-39bf-73ae-9109-1bbb7f9858a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-39bf-73ae-9109-1bbb7f9858a4",
        "storage_key": "property/6737460151191758/019d076e-39bf-73ae-9109-1bbb7f9858a4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJIZk9XBnNjIgRj8L4mDZhlrU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_41457be5-c278-40ba-b7ef-ad266a629df3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Columbus Botanical Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3603 Weems Rd, Columbus, GA 31909, USA",
      "poi_short_description": "Garden featuring trees, flowers, camellias and hiking trails.",
      "poi_long_description": "People say this botanical garden offers a variety of flowers, plants, and a pollinator garden, as well as an old farmhouse. They highlight the reasonable price and the nice walking trails. They also like the informative plant labels.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-21b5-77db-ad3a-94b54b89986c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076e-21b5-77db-ad3a-94b54b89986c",
        "storage_key": "property/6737460151191758/019d076e-21b5-77db-ad3a-94b54b89986c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.columbusbotanicalgarden.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=199339354159039876&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "columbus-botanical-garden",
      "poi_latitude": "32.5400367",
      "poi_longitude": "-84.93711689999999",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 706-327-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-39bf-73ae-9109-1bbb7f9858a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-39bf-73ae-9109-1bbb7f9858a4",
        "storage_key": "property/6737460151191758/019d076e-39bf-73ae-9109-1bbb7f9858a4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh6ExTbI084gRhMVnIhYyxAI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_ad297960-53bd-4def-8299-8abb2c431616",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Columbus Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "3250 W Britt David Rd, Columbus, GA 31909, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this airport is small, quaint, and clean, with quick and efficient TSA security.\n\nOther reviews mention the customer service can be unhelpful and the gates can close early.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-231f-721b-a2cd-e9c8c9266a69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076e-231f-721b-a2cd-e9c8c9266a69",
        "storage_key": "property/6737460151191758/019d076e-231f-721b-a2cd-e9c8c9266a69.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.flycolumbusga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14676101066280058390&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "columbus-airport",
      "poi_latitude": "32.5173373",
      "poi_longitude": "-84.9357844",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 706-324-2449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-39e2-7379-a093-2da87007bca9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-39e2-7379-a093-2da87007bca9",
        "storage_key": "property/6737460151191758/019d076e-39e2-7379-a093-2da87007bca9.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJIYyRklIz84gRFr5alyn8q8s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_f95deb10-1d67-4331-a066-5a1eebd76f4d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Aflac Paul S. Amos Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 Aflac Pkwy, Columbus, GA 31907, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-24f3-72f2-bc73-e3f7203cba2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076e-24f3-72f2-bc73-e3f7203cba2d",
        "storage_key": "property/6737460151191758/019d076e-24f3-72f2-bc73-e3f7203cba2d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17340819348860391625&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "aflac-paul-s-amos-campus",
      "poi_latitude": "32.5031259",
      "poi_longitude": "-84.8806249",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-351d-703e-b532-4f86698e3ca6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-351d-703e-b532-4f86698e3ca6",
        "storage_key": "property/6737460151191758/019d076e-351d-703e-b532-4f86698e3ca6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu749pJUz84gRyVALe1L3pvA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_37fb67d1-47d3-4637-a019-a5c892ba2093",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Char-Broil",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1442 Belfast Ave, Columbus, GA 31904, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-2811-73ae-8e0b-86c72025ca28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076e-2811-73ae-8e0b-86c72025ca28",
        "storage_key": "property/6737460151191758/019d076e-2811-73ae-8e0b-86c72025ca28.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.charbroil.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4044042022272223303&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "char-broil",
      "poi_latitude": "32.5278851",
      "poi_longitude": "-84.97202419999999",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 800-241-7548",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-351d-703e-b532-4f86698e3ca6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-351d-703e-b532-4f86698e3ca6",
        "storage_key": "property/6737460151191758/019d076e-351d-703e-b532-4f86698e3ca6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqR4hXp3MjIgRR8hJAstSHzg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_bddc37ac-7d3f-4218-8de3-537bde554c84",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "International Paper",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4847 Cargo Dr, Columbus, GA 31907, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://jobs.internationalpaper.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10481518178529247871&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "international-paper",
      "poi_latitude": "32.5134886",
      "poi_longitude": "-84.8809318",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 706-568-0050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-351d-703e-b532-4f86698e3ca6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-351d-703e-b532-4f86698e3ca6",
        "storage_key": "property/6737460151191758/019d076e-351d-703e-b532-4f86698e3ca6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqa970fIz84gRfwIJ-j_VdZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_5a1411cd-3c47-4b40-840c-73b914cd9646",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "TSYS North Data Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7101 Stone Mill Dr, Columbus, GA 31909, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-29fb-7264-a66e-609d8cce1199.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076e-29fb-7264-a66e-609d8cce1199",
        "storage_key": "property/6737460151191758/019d076e-29fb-7264-a66e-609d8cce1199.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tsys.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4355717196065526865&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "tsys-north-data-center",
      "poi_latitude": "32.5522362",
      "poi_longitude": "-84.92250659999999",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 706-322-9482",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-351d-703e-b532-4f86698e3ca6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-351d-703e-b532-4f86698e3ca6",
        "storage_key": "property/6737460151191758/019d076e-351d-703e-b532-4f86698e3ca6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE62kC8E084gRUdSLVbadcjw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f708b7b1-8e13-4404-b630-3b3d22549768",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "poi_name": "Goodwill Industries of the Southern Rivers",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2601 Cross Country Dr Building A, Columbus, GA 31907, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-2ad3-766b-99e2-134675fc4b43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d076e-2ad3-766b-99e2-134675fc4b43",
        "storage_key": "property/6737460151191758/019d076e-2ad3-766b-99e2-134675fc4b43.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://goodwillsr.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11254118981548675413&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "goodwill-industries-of-the-southern-rivers",
      "poi_latitude": "32.4847682",
      "poi_longitude": "-84.94237389999999",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 866-325-8265",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076e-351d-703e-b532-4f86698e3ca6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d076e-351d-703e-b532-4f86698e3ca6",
        "storage_key": "property/6737460151191758/019d076e-351d-703e-b532-4f86698e3ca6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAe29-tTMjIgRVZEwO5apLpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_dd83cab6-2266-4950-88a9-8b64422dbd7d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_c63fc057-300d-4fbb-845e-177ecf26ae58",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_8cd5d627-f277-4076-b820-15e64355e77b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_0c9fd1c2-ffe9-4ee0-811d-881cebfbc410",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_490e2dbf-40d9-473d-a6e7-23e3d9553576",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_7a05f182-5acd-4ec4-bbad-d07b348b2e02",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_d43608b6-3e1c-4477-bfd9-7c11bc312420",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "rating": "5",
      "name": "Robbie Schukar",
      "text": "Quiet location. Friendly faces. Keisha the office assistant is very friendly. Always smiling, very helpful and friendly.\nThe building I live in has the best neighbors. We look out for each other. Would love to see an outdoor pavilion outside the pool area. Swings would be a good extra touch.\n5 STARS ⭐⭐⭐⭐⭐",
      "date": "2026-05-01",
      "title": "false"
    },
    {
      "id": "custom_70ef0911-b65b-45a2-b2e4-85fd3da1519e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "rating": "5",
      "name": "Lois Ananing",
      "text": "My tour lady was very lovely and nice and informative.",
      "date": "2026-04-17",
      "title": "false"
    },
    {
      "id": "custom_8f989aa1-3dc7-4a69-9e33-61d3bbc6548b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "rating": "5",
      "name": "precious hinton",
      "text": "I moved in to Hampton place over a year ago. I enjoyed my apartment and during my renewal period I got a letter on my door saying my unit was down for renovation and I had to move or transfer. I was saddened by this news I loved my apartment and felt very inconvenienced by this. I loved my time here so I decided to tour the other apartments to consider transferring that’s when I met Keisha my leasing agent. Keisha has been helping me find the perfect spot to call home for over 4 months. Yes it has been a hassle but Keisha has made it slightly easier throughout the entire way. She has answered every question I’ve had, been understanding in every way possible, and has worked with me through this prolonged process. She’s kept me updated throughout the whole thing and reassured me that they were doing everything that could. It’s taken some time due to a lot of renovations being done but now I have a beautiful place to call my home thanks to Ms.Keisha.",
      "date": "2026-04-17",
      "title": "false"
    },
    {
      "id": "custom_53f77f76-14cd-4371-bc82-17ae7c922d08",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "rating": "5",
      "name": "Savannah Jane",
      "text": "Jackie is very informative, while being kind and personable. Highly recommend her to anyone for all their needs.",
      "date": "2026-04-24",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_4545ebc3-0c70-4f12-8624-ab97ab041270",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076d-8f2c-77bc-b63a-84da5187874c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a waterfall feature.",
        "public_id": "019d076d-8f2c-77bc-b63a-84da5187874c",
        "storage_key": "property/6737460151191758/019d076d-8f2c-77bc-b63a-84da5187874c.webp",
        "width": 1920,
        "height": 1280
      },
      "virtual_tour_title": "Exterior",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=6684d7112aaa007ba8d6362d"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019910d3-b344-73d4-9972-c169f2562e0b",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Hampton Place property website",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758"
    },
    {
      "lead_collector_id": "019910d3-b3ba-72d3-a023-d894b26cd18b",
      "lead_source": "FACEBOOK_ADS",
      "name": "Hampton Place facebook ads",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758"
    },
    {
      "lead_collector_id": "019910d3-b430-71ab-b881-5252d9477cd9",
      "lead_source": "LANDING_PAGE",
      "name": "Hampton Place landing page",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "page_item_url": "hampton-place-pool-apartments-east-columbus-ga",
      "search_query": "pool apartments East Columbus GA",
      "category": "Amenity",
      "h1_title": "Pool Apartments in East Columbus, GA",
      "h2_subtitle": "Discover poolside living at Hampton Place, East Columbus, GA. Enjoy great amenities in our vibrant apartment community.",
      "page_copy": "Welcome to Hampton Place, where the relaxation of poolside living meets the vibrant charm of East Columbus, GA. Our community offers a unique blend of amenities, ensuring comfort and convenience for every resident. Sound like somewhere you'd want to live? Dive into our refreshing pool and experience the joys of apartment living at its finest! Whether you choose a spacious one, two, or three-bedroom floor plan, you'll find a perfect fit for any lifestyle.\n\nNestled in the heart of East Columbus, Hampton Place provides an inviting community atmosphere with a touch of tranquility. Besides the sparkling pool, enjoy conveniences such as 24/7 availability, a sunny sundeck, and top-tier on-site management. Our residents appreciate features like balconies, ceiling fans, and washer/dryer hookups, ensuring all your needs are met. Don't miss out—explore our available units and schedule a tour today to see why Hampton Place is the ideal destination for pool apartments in East Columbus, GA.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076d-d1d7-71bc-8f65-d612cd4cb61c.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with navy blue cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019d076d-d1d7-71bc-8f65-d612cd4cb61c",
        "storage_key": "property/6737460151191758/019d076d-d1d7-71bc-8f65-d612cd4cb61c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pool Apartments in East Columbus, GA",
      "seo_description": "Explore Hampton Place's pool apartments in East Columbus, GA. Enjoy comfort and top-notch amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "page_item_url": "hampton-place-dog-park-apartments-muscogee-county",
      "search_query": "dog park apartments Muscogee County",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Muscogee County",
      "h2_subtitle": "Welcome to pet-friendly living at Hampton Place, Muscogee County. Enjoy the convenience of dog park access and exceptional amenities.",
      "page_copy": "Experience a community tailored to pet lovers at Hampton Place in Muscogee County. Our dog park apartments are designed to make life with your furry friends delightful and convenient. Nestled in East Columbus, our community offers a blend of comfort and pet-friendly amenities that cater to both you and your four-legged companions. Whether you're looking for a one, two, or three-bedroom floor plan, Hampton Place has the perfect home waiting for you and your pet.\n\nBesides our ideal location, we provide amenities that make Hampton Place stand out. Revel in comforts like well-appointed balconies, efficient ceiling fans, and handy washer/dryer hookups. Our community also ensures peace of mind with gated access and on-site management. If you're seeking a vibrant, pet-friendly environment in Muscogee County, look no further than Hampton Place. Explore our available floor plans or visit us today to discover the perfect setting where life with your pets becomes even more enjoyable.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076d-d1d7-71bc-8f65-d612cd4cb61c.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with navy blue cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019d076d-d1d7-71bc-8f65-d612cd4cb61c",
        "storage_key": "property/6737460151191758/019d076d-d1d7-71bc-8f65-d612cd4cb61c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Muscogee County",
      "seo_description": "Discover pet-friendly dog park apartments in Muscogee County at Hampton Place. Enjoy exceptional amenities for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "page_item_url": "hampton-place-fitness-center-apartments-columbus-ga",
      "search_query": "fitness center apartments Columbus GA",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Columbus, GA",
      "h2_subtitle": "Find fitness-focused living at Hampton Place, Columbus, GA. Enjoy premier amenities in our vibrant community.",
      "page_copy": "Welcome to Hampton Place, a community that combines convenience and well-being right in the heart of Columbus, GA. Although our amenities extend beyond a fitness center, we offer a lifestyle that encourages active living and well-rounded leisure activities. Here, you can choose from a variety of distinct floor plans, including one, two, and three-bedroom options, all designed with your comfort in mind.\n\nLocated in the vibrant East Columbus neighborhood, Hampton Place has everything you need for a full lifestyle. While we focus on promoting a healthy lifestyle, our community features also include enjoyable amenities such as a sparkling swimming pool, delightful sundeck, and reliable on-site management. Whether you want to maintain an active lifestyle or simply unwind, Hampton Place in Columbus offers the perfect backdrop. Explore the possibilities today by viewing our available units or scheduling a tour of our welcoming community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076d-d1d7-71bc-8f65-d612cd4cb61c.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with navy blue cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019d076d-d1d7-71bc-8f65-d612cd4cb61c",
        "storage_key": "property/6737460151191758/019d076d-d1d7-71bc-8f65-d612cd4cb61c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in Columbus, GA",
      "seo_description": "Explore Hampton Place, your destination for fitness center apartments in Columbus, GA. Enjoy amenities that fit an active lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "page_item_url": "hampton-place-in-unit-laundry-apartments-31907",
      "search_query": "in-unit laundry apartments 31907",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in 31907",
      "h2_subtitle": "Enjoy the convenience of in-unit laundry at Hampton Place in the 31907 area. Discover a pet-friendly community with top-notch amenities.",
      "page_copy": "Welcome to Hampton Place, where the convenience of in-unit laundry meets comfortable living in the 31907 area of Columbus, GA. Our community offers thoughtfully designed one, two, and three-bedroom floor plans that cater to modern lifestyles. Each apartment is equipped with washer/dryer hookups, allowing you to enjoy the ultimate convenience right in your home.\n\nSituated in the vibrant neighborhood of East Columbus, Hampton Place combines a welcoming atmosphere with exceptional amenities. Beyond in-unit laundry, residents can enjoy features such as cheerful balconies, efficient ceiling fans, and a gated community for added security. Experience a lifestyle that's both comfortable and practical, with on-site management available 24/7 to assist with your needs. Discover why so many choose Hampton Place—explore our available apartments or arrange a visit today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076d-d1d7-71bc-8f65-d612cd4cb61c.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with navy blue cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019d076d-d1d7-71bc-8f65-d612cd4cb61c",
        "storage_key": "property/6737460151191758/019d076d-d1d7-71bc-8f65-d612cd4cb61c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in 31907",
      "seo_description": "Find in-unit laundry apartments at Hampton Place, 31907. Enjoy pet-friendly living with excellent amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "page_item_url": "hampton-place-air-conditioned-apartments-east-columbus",
      "search_query": "air conditioned apartments East Columbus",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in East Columbus",
      "h2_subtitle": "Stay cool at Hampton Place's air conditioned apartments in East Columbus. Discover a range of floor plans and exceptional amenities.",
      "page_copy": "Welcome to Hampton Place, your serene retreat featuring air conditioned apartments in the vibrant area of East Columbus. Our community offers a selection of one, two, and three-bedroom floor plans, ensuring you find the perfect fit for your lifestyle. All of our apartments are equipped with effective air conditioning systems, providing a cool haven during Georgia’s warmer months.\n\nLocated in the heart of East Columbus, Hampton Place offers more than just air conditioned comfort. Residents enjoy modern amenities like private balconies, gated entry, and convenient in-unit washer/dryer hookups, all managed by attentive on-site staff committed to making your living experience exceptional. With 24/7 availability, Hampton Place is dedicated to providing a worry-free atmosphere. We invite you to explore our available units today and experience why our community is the preferred choice for comfortable living in East Columbus.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076d-d1d7-71bc-8f65-d612cd4cb61c.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with navy blue cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019d076d-d1d7-71bc-8f65-d612cd4cb61c",
        "storage_key": "property/6737460151191758/019d076d-d1d7-71bc-8f65-d612cd4cb61c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in East Columbus",
      "seo_description": "Discover air conditioned apartments in East Columbus at Hampton Place. Enjoy modern amenities and a comfortable, welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "page_item_url": "hampton-place-one-bedroom-apartments-east-columbus",
      "search_query": "one bedroom apartments east columbus",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in East Columbus",
      "h2_subtitle": "Explore one bedroom apartments at Hampton Place in East Columbus. Find comfort and convenience in our vibrant community.",
      "page_copy": "Discover the perfect blend of comfort and convenience at Hampton Place in East Columbus, offering delightful one bedroom apartments tailored to fit your lifestyle. Each unit is designed with you in mind, featuring amenities such as efficient air conditioning, ceiling fans, and washer/dryer hookups, making everyday living more enjoyable.\n\nNestled in the inviting neighborhood of East Columbus, Hampton Place offers more than just a place to live; it provides a welcoming community with exceptional features like private balconies and a secure, gated environment. With on-site management available around the clock, every need is promptly attended to, ensuring a seamless living experience. Consider making Hampton Place your new home and explore our one bedroom apartment offerings today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076d-d1d7-71bc-8f65-d612cd4cb61c.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with navy blue cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019d076d-d1d7-71bc-8f65-d612cd4cb61c",
        "storage_key": "property/6737460151191758/019d076d-d1d7-71bc-8f65-d612cd4cb61c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in East Columbus",
      "seo_description": "Find your home at Hampton Place with spacious one bedroom apartments in East Columbus. Enjoy outstanding amenities in a warm, welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "page_item_url": "hampton-place-two-bedroom-apartments-muscogee-county",
      "search_query": "two bedroom apartments muscogee county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Muscogee County",
      "h2_subtitle": "Discover spacious two bedroom apartments at Hampton Place in Muscogee County. Enjoy a community with top-tier amenities.",
      "page_copy": "Experience the best of Muscogee County by choosing a two bedroom apartment at Hampton Place. Our thoughtfully designed units offer ample space and comfort, making them ideal for families or those seeking extra room. Each apartment comes equipped with modern amenities including washer/dryer hookups, air conditioning, and private balconies, ensuring a comfortable lifestyle.\n\nLocated in the heart of Muscogee County, Hampton Place stands out with its vibrant community features such as a gated entrance, ceiling fans, and 24/7 on-site management, dedicated to enhancing your living experience. Positioned in the dynamic area of East Columbus, our two bedroom apartments are not only conveniently located but also offer a tranquil retreat from the hustle and bustle. We invite you to explore our available units and discover why Hampton Place is the perfect home for you in Muscogee County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076d-d1d7-71bc-8f65-d612cd4cb61c.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with navy blue cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019d076d-d1d7-71bc-8f65-d612cd4cb61c",
        "storage_key": "property/6737460151191758/019d076d-d1d7-71bc-8f65-d612cd4cb61c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Muscogee County",
      "seo_description": "Spacious two bedroom apartments available at Hampton Place in Muscogee County. Experience a warm community with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191758",
      "source": "generator",
      "page_item_url": "hampton-place-three-bedroom-apartments-columbus-ga-31907",
      "search_query": "three bedroom apartments columbus ga 31907",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Columbus, GA 31907",
      "h2_subtitle": "Explore three bedroom apartments at Hampton Place in Columbus, GA 31907. Perfect for families seeking ample space and modern amenities.",
      "page_copy": "Welcome to Hampton Place, where spacious three bedroom apartments await you in the vibrant city of Columbus, GA, 31907 area. Our generously sized units are perfect for families or those desiring additional space, featuring expansive layouts, modern kitchens, and private balconies that offer an ideal setting for relaxation.\n\nNestled within East Columbus, Hampton Place offers a suite of amenities designed for comfort and convenience, including air conditioning, washer/dryer hookups, and ceiling fans. The community is secured with gated access and operates with 24/7 on-site management, ensuring a safe and welcoming environment. Embrace the lively and friendly community atmosphere in one of Columbus’s most sought-after neighborhoods. We invite you to explore our three bedroom offerings and make Hampton Place your new home today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191758/019d076d-d1d7-71bc-8f65-d612cd4cb61c.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with navy blue cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019d076d-d1d7-71bc-8f65-d612cd4cb61c",
        "storage_key": "property/6737460151191758/019d076d-d1d7-71bc-8f65-d612cd4cb61c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Columbus, GA 31907",
      "seo_description": "Find spacious three bedroom apartments at Hampton Place in Columbus, GA 31907. Enjoy modern amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3352"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483404"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4601281"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.hamptonplaceapts.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.hamptonplaceapts.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.hamptonplaceapts.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.hamptonplaceapts.com?utm_knock=w"
    },
    {
      "ID": "custom_knock_z_link",
      "type": "STRING",
      "value": "https://www.hamptonplaceapts.com?utm_knock=z"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PBBB75HM"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.hamptonplaceapts.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.hamptonplaceapts.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.hamptonplaceapts.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.hamptonplaceapts.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.hamptonplaceapts.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.hamptonplaceapts.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_z_title",
      "type": "STRING",
      "value": "Zillow"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "706-600-2787"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.hamptonplaceapts.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.hamptonplaceapts.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "706-600-2891"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.hamptonplaceapts.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.hamptonplaceapts.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.hamptonplaceapts.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.hamptonplaceapts.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "706-600-2820"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "706-600-2546"
    },
    {
      "ID": "custom_knock_z_number",
      "type": "STRING",
      "value": "706-539-5972"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "706-600-2829"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.hamptonplaceapts.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "706-600-2650"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "706-600-2498"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "706-600-2598"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "706-600-2877"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "706-710-6443"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.hamptonplaceapts.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "706-748-7848"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.hamptonplaceapts.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "706-600-2299"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.hamptonplaceapts.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "706-800-9362"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "706-967-2879"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.hamptonplaceapts.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "706-460-4759"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "706-960-6493"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "706-909-2482"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.hamptonplaceapts.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.hamptonplaceapts.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "706-539-5530"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321196192"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "706-600-2906"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "706-954-5292"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.hamptonplaceapts.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "1ee0cbca1c217581"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.hamptonplaceapts.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "706-740-7659"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.hamptonplaceapts.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "706-600-2830"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "706-600-2858"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.hamptonplaceapts.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "706-940-4804"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "706-600-2850"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "706-600-2746"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "706-600-2873"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.hamptonplaceapts.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151191758/019e8479-cef7-75ae-a9f0-fa332d774f76.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "706-600-2894"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "706-710-6443"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3352",
  "custom_repli_id": "5028483404",
  "custom_realpage_id": "4601281",
  "custom_knock_a_link": "https://www.hamptonplaceapts.com?utm_knock=a",
  "custom_knock_g_link": "https://www.hamptonplaceapts.com?utm_knock=g",
  "custom_knock_r_link": "https://www.hamptonplaceapts.com?utm_knock=r",
  "custom_knock_w_link": "https://www.hamptonplaceapts.com?utm_knock=w",
  "custom_knock_z_link": "https://www.hamptonplaceapts.com?utm_knock=z",
  "custom_google_gtm_id": "GTM-PBBB75HM",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.hamptonplaceapts.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.hamptonplaceapts.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.hamptonplaceapts.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.hamptonplaceapts.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.hamptonplaceapts.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.hamptonplaceapts.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_z_title": "Zillow",
  "custom_knock_a_number": "706-600-2787",
  "custom_knock_ads_link": "https://www.hamptonplaceapts.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.hamptonplaceapts.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "706-600-2891",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.hamptonplaceapts.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.hamptonplaceapts.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.hamptonplaceapts.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.hamptonplaceapts.com?utm_knock=psa",
  "custom_knock_r_number": "706-600-2820",
  "custom_knock_w_number": "706-600-2546",
  "custom_knock_z_number": "706-539-5972",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "706-600-2829",
  "custom_knock_amap_link": "https://www.hamptonplaceapts.com?utm_knock=amap",
  "custom_knock_ar_number": "706-600-2650",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "706-600-2498",
  "custom_knock_fb_number": "706-600-2598",
  "custom_knock_fl_number": "706-600-2877",
  "custom_knock_gp_number": "706-710-6443",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.hamptonplaceapts.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "full_stack",
  "custom_knock_ads_number": "706-748-7848",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.hamptonplaceapts.com?utm_knock=bcard",
  "custom_knock_bnr_number": "706-600-2299",
  "custom_knock_cfres_link": "https://www.hamptonplaceapts.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "706-800-9362",
  "custom_knock_lgp_number": "706-967-2879",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.hamptonplaceapts.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "706-460-4759",
  "custom_knock_psa_number": "706-960-6493",
  "custom_seo_subscription": "full_stack",
  "custom_knock_amap_number": "706-909-2482",
  "custom_knock_bandit_link": "https://www.hamptonplaceapts.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.hamptonplaceapts.com?utm_knock=flyers",
  "custom_knock_osoc_number": "706-539-5530",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321196192",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "706-600-2906",
  "custom_knock_cfres_number": "706-954-5292",
  "custom_knock_chatgpt_link": "https://www.hamptonplaceapts.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "1ee0cbca1c217581",
  "custom_knock_dirmail_link": "https://www.hamptonplaceapts.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "706-740-7659",
  "custom_knock_propbro_link": "https://www.hamptonplaceapts.com?utm_knock=propbro",
  "custom_knock_bandit_number": "706-600-2830",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "706-600-2858",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.hamptonplaceapts.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "706-940-4804",
  "custom_knock_dirmail_number": "706-600-2850",
  "custom_knock_propbro_number": "706-600-2746",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "706-600-2873",
  "custom_knock_maintenance_link": "https://www.hamptonplaceapts.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151191758/019e8479-cef7-75ae-a9f0-fa332d774f76.mp4",
  "custom_knock_maintenance_number": "706-600-2894",
  "custom_ppc_tracking_phone_number": "706-710-6443"
};

export const generatedAt = '2026-10-07T17:16:29.407Z';
